var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _radialGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWikipedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.438,
    x2: -18.298,
    y1: 26.868,
    y2: -48.704,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b8b8b8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    style: {
      stopColor: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    style: {
      stopColor: "#2e2e2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    style: {
      stopColor: "#151515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    style: {
      stopColor: "#050505"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -57.486,
    x2: -70.399,
    y1: -55.793,
    y2: 36.803,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    style: {
      stopColor: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    style: {
      stopColor: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    style: {
      stopColor: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    style: {
      stopColor: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    style: {
      stopColor: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    style: {
      stopColor: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    style: {
      stopColor: "#f3f3f3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    style: {
      stopColor: "#bcbcbc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    style: {
      stopColor: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    style: {
      stopColor: "#a9a9a9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    style: {
      stopColor: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    style: {
      stopColor: "#767676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    style: {
      stopColor: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    style: {
      stopColor: "#b6b6b6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    style: {
      stopColor: "#6c6c6c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    style: {
      stopColor: "#5e5e5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#737373"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -47.309,
    x2: -60.248,
    y1: -54.421,
    y2: 38.365,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    style: {
      stopColor: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    style: {
      stopColor: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    style: {
      stopColor: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    style: {
      stopColor: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    style: {
      stopColor: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    style: {
      stopColor: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    style: {
      stopColor: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    style: {
      stopColor: "#f3f3f3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    style: {
      stopColor: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    style: {
      stopColor: "#bcbcbc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    style: {
      stopColor: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    style: {
      stopColor: "#a9a9a9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    style: {
      stopColor: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    style: {
      stopColor: "#767676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    style: {
      stopColor: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    style: {
      stopColor: "#b6b6b6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    style: {
      stopColor: "#6c6c6c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    style: {
      stopColor: "#5e5e5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#737373"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -45.237,
    x2: -24.687,
    y1: -42.195,
    y2: 34.15,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    style: {
      stopColor: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    style: {
      stopColor: "#a9a9a9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    style: {
      stopColor: "#898989"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    style: {
      stopColor: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    style: {
      stopColor: "#5f5f5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#787878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    style: {
      stopColor: "#6f6f6f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#474747"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -33.68,
    x2: -6.179,
    y1: -44.192,
    y2: 39.56,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    style: {
      stopColor: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    style: {
      stopColor: "#eee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    style: {
      stopColor: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    style: {
      stopColor: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    style: {
      stopColor: "#b8b8b8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3b3b3b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -18.072,
    x2: 9.409,
    y1: -49.256,
    y2: 34.438,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    style: {
      stopColor: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    style: {
      stopColor: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    style: {
      stopColor: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    style: {
      stopColor: "#adadad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3b3b3b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -27.649,
    x2: -0.136,
    y1: -46.209,
    y2: 37.582,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    style: {
      stopColor: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    style: {
      stopColor: "#eee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    style: {
      stopColor: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    style: {
      stopColor: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    style: {
      stopColor: "#b8b8b8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3b3b3b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -44.995,
    x2: -25.076,
    y1: -42.281,
    y2: 31.716,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    style: {
      stopColor: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    style: {
      stopColor: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    style: {
      stopColor: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    style: {
      stopColor: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    style: {
      stopColor: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    style: {
      stopColor: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    style: {
      stopColor: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    style: {
      stopColor: "#9e9e9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    style: {
      stopColor: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    style: {
      stopColor: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    style: {
      stopColor: "#adadad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#474747"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -25.521,
    x2: -44.244,
    y1: -46.319,
    y2: 44.79,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -55.704,
    x2: -73.802,
    y1: -49.747,
    y2: 38.319,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -60.744,
    x2: -78.414,
    y1: -50.645,
    y2: 35.336,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -39.776,
    x2: -39.784,
    y1: 34.228,
    y2: 34.265,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -59.421,
    x2: -77.525,
    y1: -50.506,
    y2: 37.591,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -60.06,
    x2: -78.157,
    y1: -50.638,
    y2: 37.42,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -31.385,
    x2: -49.477,
    y1: -44.73,
    y2: 43.309,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -44.852,
    x2: -62.949,
    y1: -47.518,
    y2: 40.543,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -37.232,
    x2: -55.379,
    y1: -46.168,
    y2: 42.135,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -29.159,
    x2: -47.866,
    y1: -47.004,
    y2: 44.024,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -26.032,
    x2: -44.109,
    y1: -43.562,
    y2: 44.403,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    style: {
      stopColor: "#747474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    style: {
      stopColor: "#888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#a2a2a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    style: {
      stopColor: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d4d4d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -75.852,
    x2: -75.673,
    y1: 11.153,
    y2: 11.153,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    style: {
      stopColor: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#6b6b6b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    style: {
      stopColor: "#5f5f5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    style: {
      stopColor: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    style: {
      stopColor: "#383838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#1b1b1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -75.647,
    x2: 12.502,
    y1: 6.717,
    y2: 6.717,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    style: {
      stopColor: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    style: {
      stopColor: "gray"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    style: {
      stopColor: "#797979"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    style: {
      stopColor: "#6e6e6e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    style: {
      stopColor: "#6b6b6b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4e4e4e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -81.984,
    x2: 10.991,
    y1: -10.464,
    y2: -10.464,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5e5e5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    style: {
      stopColor: "#353535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    style: {
      stopColor: "#0f0f0f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    style: {
      stopColor: "#555"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#575757"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -81.705,
    x2: 3.631,
    y1: -29.543,
    y2: -29.543,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    style: {
      stopColor: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    style: {
      stopColor: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    style: {
      stopColor: "#878787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    style: {
      stopColor: "#494949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    style: {
      stopColor: "#393939"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    style: {
      stopColor: "#343434"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    style: {
      stopColor: "#383838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    style: {
      stopColor: "#5b5b5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#797979"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    style: {
      stopColor: "#9f9f9f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    style: {
      stopColor: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -79.136,
    x2: -79.136,
    y1: -5.441,
    y2: -5.441,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    style: {
      stopColor: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    style: {
      stopColor: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#9a9a9a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    style: {
      stopColor: "#5b5b5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#575757"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: -82.24,
    x2: 18.891,
    y1: -5.666,
    y2: -16.87,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    style: {
      stopColor: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    style: {
      stopColor: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#9a9a9a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    style: {
      stopColor: "#5b5b5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#575757"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: -82.675,
    x2: 32.823,
    y1: -5.694,
    y2: -18.49,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    style: {
      stopColor: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    style: {
      stopColor: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#9a9a9a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    style: {
      stopColor: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    style: {
      stopColor: "#5b5b5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#575757"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: -82.003,
    x2: 19.141,
    y1: -3.536,
    y2: -14.742,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    style: {
      stopColor: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    style: {
      stopColor: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    style: {
      stopColor: "#787878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#9a9a9a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    style: {
      stopColor: "#5b5b5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#575757"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: -80.6,
    x2: 21.633,
    y1: 12.046,
    y2: -6.471,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    style: {
      stopColor: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    style: {
      stopColor: "#9b9b9b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#8b8b8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    style: {
      stopColor: "#757575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    style: {
      stopColor: "#333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: -78.991,
    x2: 22.981,
    y1: 20.908,
    y2: 2.438,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    style: {
      stopColor: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    style: {
      stopColor: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "silver"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    style: {
      stopColor: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    style: {
      stopColor: "#adadad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    style: {
      stopColor: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#8b8b8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    style: {
      stopColor: "#757575"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: -80.643,
    x2: 21.419,
    y1: 12.257,
    y2: -6.229,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    style: {
      stopColor: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    style: {
      stopColor: "#9b9b9b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#8b8b8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    style: {
      stopColor: "#757575"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: -80.226,
    x2: 21.784,
    y1: 14.052,
    y2: -4.425,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    style: {
      stopColor: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    style: {
      stopColor: "#9b9b9b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#8b8b8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    style: {
      stopColor: "#757575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    style: {
      stopColor: "#333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: -80.162,
    x2: 22.181,
    y1: 14.547,
    y2: -3.99,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    style: {
      stopColor: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    style: {
      stopColor: "#9b9b9b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#8b8b8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    style: {
      stopColor: "#757575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    style: {
      stopColor: "#333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: -80.308,
    x2: 21.931,
    y1: 14.946,
    y2: -3.573,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    style: {
      stopColor: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    style: {
      stopColor: "#919191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    style: {
      stopColor: "#9b9b9b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    style: {
      stopColor: "#8b8b8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    style: {
      stopColor: "#757575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    style: {
      stopColor: "#333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: -74.644,
    x2: 8.63,
    y1: -19.993,
    y2: -39.788,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    style: {
      stopColor: "#343434"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    style: {
      stopColor: "#a3a3a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: -66.491,
    x2: -36.319,
    y1: -32.345,
    y2: -32.345,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#2e2e2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    style: {
      stopColor: "#424242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#303030"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: -66.124,
    x2: -36.432,
    y1: -33.097,
    y2: -33.097,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    style: {
      stopColor: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#adadad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    style: {
      stopColor: "#9d9d9d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#818181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    style: {
      stopColor: "#6a6a6a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    style: {
      stopColor: "#585858"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    style: {
      stopColor: "#4c4c4c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    style: {
      stopColor: "#444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    style: {
      stopColor: "#424242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#bdbdbd"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: -61.194,
    x2: -62.152,
    y1: -23.532,
    y2: -29.872,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: -62.676,
    x2: -61.093,
    y1: -30.049,
    y2: -22.25,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2e2e2e"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "O",
    x1: 0.438,
    x2: -18.298,
    y1: 26.868,
    y2: -48.704,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "P",
    x1: -57.486,
    x2: -70.399,
    y1: -55.793,
    y2: 36.803,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#d",
    id: "Q",
    x1: -47.309,
    x2: -60.248,
    y1: -54.421,
    y2: 38.365,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#e",
    id: "R",
    x1: -45.237,
    x2: -24.687,
    y1: -42.195,
    y2: 34.15,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#f",
    id: "S",
    x1: -33.68,
    x2: -6.179,
    y1: -44.192,
    y2: 39.56,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#g",
    id: "T",
    x1: -18.072,
    x2: 9.409,
    y1: -49.256,
    y2: 34.438,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#h",
    id: "U",
    x1: -27.649,
    x2: -0.136,
    y1: -46.209,
    y2: 37.582,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#i",
    id: "V",
    x1: -44.995,
    x2: -25.076,
    y1: -42.281,
    y2: 31.716,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#j",
    id: "W",
    x1: -25.521,
    x2: -44.244,
    y1: -46.319,
    y2: 44.79,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#k",
    id: "X",
    x1: -55.704,
    x2: -73.802,
    y1: -49.747,
    y2: 38.319,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#l",
    id: "Y",
    x1: -60.744,
    x2: -78.414,
    y1: -50.645,
    y2: 35.336,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#m",
    id: "Z",
    x1: -39.776,
    x2: -39.784,
    y1: 34.228,
    y2: 34.265,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#n",
    id: "aa",
    x1: -59.421,
    x2: -77.525,
    y1: -50.506,
    y2: 37.591,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#o",
    id: "ab",
    x1: -60.06,
    x2: -78.157,
    y1: -50.638,
    y2: 37.42,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#p",
    id: "ac",
    x1: -31.385,
    x2: -49.477,
    y1: -44.73,
    y2: 43.309,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#q",
    id: "ad",
    x1: -44.852,
    x2: -62.949,
    y1: -47.518,
    y2: 40.543,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#r",
    id: "ae",
    x1: -37.232,
    x2: -55.379,
    y1: -46.168,
    y2: 42.135,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#s",
    id: "af",
    x1: -29.159,
    x2: -47.866,
    y1: -47.004,
    y2: 44.024,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#t",
    id: "ag",
    x1: -26.032,
    x2: -44.109,
    y1: -43.562,
    y2: 44.403,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#u",
    id: "ah",
    x1: -75.852,
    x2: -75.673,
    y1: 11.153,
    y2: 11.153,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#v",
    id: "ai",
    x1: -75.647,
    x2: 12.502,
    y1: 6.717,
    y2: 6.717,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#w",
    id: "aj",
    x1: -81.984,
    x2: 10.991,
    y1: -10.464,
    y2: -10.464,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#x",
    id: "ak",
    x1: -81.705,
    x2: 3.631,
    y1: -29.543,
    y2: -29.543,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#y",
    id: "al",
    x1: -79.136,
    x2: -79.136,
    y1: -5.441,
    y2: -5.441,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#z",
    id: "am",
    x1: -82.24,
    x2: 18.891,
    y1: -5.666,
    y2: -16.87,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#A",
    id: "an",
    x1: -82.675,
    x2: 32.823,
    y1: -5.694,
    y2: -18.49,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#B",
    id: "ao",
    x1: -82.003,
    x2: 19.141,
    y1: -3.536,
    y2: -14.742,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#C",
    id: "ap",
    x1: -80.6,
    x2: 21.633,
    y1: 12.046,
    y2: -6.471,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#D",
    id: "aq",
    x1: -78.991,
    x2: 22.981,
    y1: 20.908,
    y2: 2.438,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#E",
    id: "ar",
    x1: -80.643,
    x2: 21.419,
    y1: 12.257,
    y2: -6.229,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#F",
    id: "as",
    x1: -80.226,
    x2: 21.784,
    y1: 14.052,
    y2: -4.425,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#G",
    id: "at",
    x1: -80.162,
    x2: 22.181,
    y1: 14.547,
    y2: -3.99,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#H",
    id: "au",
    x1: -80.308,
    x2: 21.931,
    y1: 14.946,
    y2: -3.573,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#I",
    id: "av",
    x1: -74.644,
    x2: 8.63,
    y1: -19.993,
    y2: -39.788,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#J",
    id: "aw",
    x1: -66.491,
    x2: -36.319,
    y1: -32.345,
    y2: -32.345,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#K",
    id: "ax",
    x1: -66.124,
    x2: -36.432,
    y1: -33.097,
    y2: -33.097,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#L",
    id: "ay",
    x1: -61.194,
    x2: -62.152,
    y1: -23.532,
    y2: -29.872,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#M",
    id: "az",
    x1: -62.676,
    x2: -61.093,
    y1: -30.049,
    y2: -22.25,
    gradientTransform: "translate(102.4 79.1)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: -54.063,
    cy: -14.398,
    r: 63.986,
    fx: -54.063,
    fy: -14.398,
    gradientTransform: "matrix(1.04177 .01283 -.01232 .99992 104.481 79.792)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    style: {
      stopColor: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    style: {
      stopColor: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    style: {
      stopColor: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#393939"
    }
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "N",
    cx: -54.063,
    cy: -14.398,
    r: 63.986,
    fx: -54.063,
    fy: -14.398,
    gradientTransform: "matrix(1.04177 .01283 -.01232 .99992 104.481 79.792)",
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M66.076 42.687c.013-.565-.365-1.183-.365-1.183l-.024-.054s-.453-.884-1.212-1.144-1.377.319-1.377.319l-.399.46c-.292.339-.472.62-1.116.874-.645.252-1.285.19-1.624.03s-.426-.5-.426-.5-.213-.672-.292-.977c-.08-.308-.287-1.578-.287-1.578s-.458-2.559-.498-3.078c0 0 1.374-.118 3.434-.722 2.142-.627 2.835-1.123 2.835-1.123s-.402-.146-.451-.617c-.048-.472-.083-1.109-.083-1.109s-.083-.465.45-1.061 1.262-.804 1.642-.888c.382-.083 1.193-.158 1.95-.125.755.035 1.178.104 1.483.271.306.166.333.569.333.569l-.007 1.067s-.034.375.242.493c0 0 .471.284 2.047.124 0 0 .67-.118 1.719-.429a418 418 0 0 1 4.242-1.249c.395-.104.888-.271 1.532-.437.645-.167 1.9-.583 2.149-.68s1.685-.576 2.726-.755c1.039-.181 2.072-.173 2.62.139 0 0 .333.284.486.617.151.333.442.804.857 1.013.425.211.701.346 1.748.255 0 0 .021-.09-.367-.345a27 27 0 0 1-.923-.653s-.312-.228-.382-.416c-.068-.188-.04-.285-.04-.285l.817-1.31s0-.16.472-.221c.471-.063.999-.125 1.623-.292.623-.166.734-.291.734-.291l.54.166s3.303 2.658 4.336 3.338l.187-.222s.406.016.771.16c.365.143.912.524.912.524s1.503 1.22 1.93 2.049l.206.632-.093.15s.855 1.217 1.951 2.423c0 0 1.143 1.55 1.575 1.947 0 0-.103-.372-.188-.791l.313-.21.189-.134.575.241c3.33 4.482 5.992 9.711 7.584 15.211l-.112.451.367.467a47.6 47.6 0 0 1 1.609 12.307q-.001 1.568-.101 3.111l-.283.476.209.517c-2.08 24.312-22.474 43.396-47.325 43.396-17.236 0-32.327-9.179-40.651-22.915l-.095-.34-.191-.143a47.2 47.2 0 0 1-6.144-17.796l.198-.489-.313-.45a48 48 0 0 1-.3-5.364c0-2.781.238-5.505.697-8.156l.232-.524-.081-.306a47.2 47.2 0 0 1 6.031-15.649l.637-.358.076.03s.217-.157.329-.202l.07-.021s1.099-1.836 1.514-2.423c0 0 .505-.324.693-.379 0 0 .116-.015.177.071 0 0 .462-.402 1.583-1.913l.011-.016s-.106-.071-.122-.162c-.016-.09.101-.55.162-.668s.101-.145.101-.145 1.604-1.893 2.935-3.016c0 0 .242-.188.632-.233 0 0 1.371-.571 3.041-2.034 0 0 .047-.269.445-.8.399-.531 1.356-1.083 2.07-1.245.712-.162.835-.035.835-.035l.06.061.48.713s.526-.294 1.316-.562c.789-.269.912-.244.912-.244l.769 1.245-.92 1.863s-.6 1.324-1.542 2.035c0 0-.44.265-1.043.119-.604-.146-.999.31-.999.31l-.158.13s.13-.023.322-.096c0 0 .147.061.255.208.106.147.85 1.095.85 1.095s.005.78-.386 1.806c-.39 1.025-1.367 2.693-1.367 2.693s-.683 1.326-1.001 2.099-.48 1.644-.455 2.107c0 0 .174.058.659-.188.61-.309 1.008.025 1.008.025s.67.494.97.821c.244.269.747 1.644.195 3.003 0 0-.375.939-1.283 1.606 0 0-.201.309-1.425.162-.342-.04-.545-.257-1.277-.186s-1.147.76-1.147.76l.012-.023c-.645.93-1.075 2.29-1.075 2.29l-.053.153s-.224.474-.272 1.632c-.049 1.196.265 2.896.265 2.896s7.337-1.292 9.204-.051l.54.496s.043.162-.029.35c-.074.19-.349.627-.919 1.037-.569.408-1.138 1.474-.292 2.146.963.762 1.576.714 3.195.436 1.621-.276 2.7-1.182 2.7-1.182s.906-.671.729-1.517c-.175-.846-.947-1.108-.947-1.108s-.613-.394-.132-1.153c0 0 .132-.642 2.379-1.226 2.248-.583 6.346-1.416 9.834-1.853 0 0-2.365-7.66-.687-8.653 0 0 .408-.276 1.14-.38l.671-.035c.122-.025.32.005.741.042.422.035.933.071 1.563-.411.63-.483.65-.763.65-.763",
    style: {
      fill: "url(#N)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.443 100.726.421.157-.093.167c-.806 1.465-.871 1.795-1.268 2.099-.396.303-.54.502-1.345.647-.807.146-1.65 1.094-1.65 1.094s-.817.779-.449.807c.37.026 1.095-.567 1.095-.567s.463-.33.582-.238-.502.7-.502.7-1.082 1.095-2.309 1.847l-.37.198s1.741-1.294 2.573-2.229c0 0 .171-.252-.171.052-.343.304-1.241.766-1.623.766-.383 0 .014-.527.014-.527s.554-.713 1.688-1.636c1.136-.926 2.086-.859 2.086-.859s.21.04.236-.251c.027-.29.291-.804.291-.804s.422-.964 1.557-2.561c1.134-1.597 1.648-2.046 1.648-2.046s1.479-1.518 2.258-3.035c0 0 .541-.937-.343-.237s-2.059 1.583-3.205 1.874c-1.149.29-1.255-.779-1.255-.779s-.252-1.754.976-3.113c1.108-1.228 2.323-1.188 3.432-1.319 1.107-.133 2.059-1.465 2.059-1.465s.764-.858 1.2-3.537c.203-1.244.063-2.09-.132-2.624l.02-.605-.345-.019c-.073-.099-.124-.143-.124-.143s-.277-.278-.568-.488c-.29-.211-.645-.607-.989-1.359 0 0-.947-1.966-.738-4.803.21-2.837 2.573-2.573 2.573-2.573s1.373.132 1.637-.277c.265-.409.515-.925.607-2.071.092-1.149-.37-2.243-.37-2.243s-.171-.568-.976-.66c-.806-.093-.978.157-.978.157s-.237.067-.673 1.016c-.437.951-.699 1.386-1.491 1.585-.791.197-1.886.092-2.375-.924-.479-.999-1.636-3.44-2.189-5.377l.079-.685-.303-.439a10 10 0 0 1-.121-1.152c-.025-.924-.289-1.953-.593-2.981-.305-1.03-1.361-2.769-1.558-3.167-.303-.621-.58-.884-.95-.832-.368.053-.316.053-.475.053-.157 0-.249.197-.29.396-.039.197-.349 1.225-1.029 1.688-.699.475-1.069.687-2.27.792 0 0-1.386.092-2.48-1.954-1.096-2.046-.817-3.351-.726-3.826s.501-1.161 1.147-1.293 1.042-.171 1.042-.171 1.046-.009 1.492-.066c.514-.066.264-.938.264-.938s-.336-2.209-2.186-4.022l-.087-.454-.705-.355c-1.753-1.9-4.056-4.987-4.056-4.987s-1.029-.976-.158-2.323c0 0 .408-.897 1.623-.738.391.075.426.114.764.185.449.092.938.21 1.375-.371 0 0 .408-.738-.251-1.688-.661-.95-.859-1.623-1.663-1.571 0 0-.371-.052-.739.358-.37.408-1.321.667-1.875.725-.632.066-2.097-.492-2.941-1.94-.476-.814-.701-1.257-.807-1.486l.218-.316.669.074c.172.334.511.984.91 1.688.514.911.976 1.042 1.279 1.175.304.131.977-.066 1.333-.264.357-.198.713-.647 1.332-.687.621-.04 1.518.066 2.151.739s1.426 2.072 1.359 2.731-.106 1.307-.964 1.583c-.859.277-1.214.04-1.755-.079-.542-.12-.806-.067-1.028.197-.226.265-.476.831-.383 1.082s.171.423.698 1.176c.528.751 3.234 3.959 3.756 4.44l-.143.65.901.164c.582.674 1.266 1.554 1.569 2.108.461.845.7 2.177.727 2.797.025.62-.278.897-.278.897s-.29.488-1.873.488c-1.412 0-1.505.277-1.505.277s-.435.435-.343 1.504c.093 1.068.574 2.184 1.451 3.14.726.792 2.097-.006 2.561-.275.474-.279.766-1.177.766-1.177s.093-1.134 1.333-1.134c1.282 0 1.834 1.228 1.834 1.228s.896 1.207 1.808 3.839c.449 1.294.529 2.125.529 2.125l.117 1.554-.475.831.682.291a13 13 0 0 0 .637 1.904s.938 2.218 1.347 3.062.831.713 1.175.752c0 0 .791.105 1.081-.263.292-.371.569-1.017.569-1.017s.619-1.688 1.991-1.544c1.373.145 1.715 1.017 1.953 2.02.237 1.001.29 3.007-.448 4.234-.741 1.228-1.57 1.057-1.57 1.057s-1.69-.159-2.072.198c-.383.355-.58.673-.633 1.503-.053.831.025 2.177.699 3.8.588 1.42 1.069 1.268 1.333 1.609.265.344 1.107 1.122 1.028 3.049s-.737 3.866-1.477 5.067-1.861 1.913-1.861 1.913-.316.197-1.003.29c-.685.093-1.663.079-2.361.476s-.925 1.398-.99 1.835c-.065.434-.105 1.425.858 1.317.963-.104 2.401-1.306 2.401-1.306s1.385-1.029 1.569-.7c.185.33-.592 1.663-.592 1.663s-.965 1.452-1.769 2.351c-.662.736-1.528 1.741-2.264 2.888z",
    style: {
      opacity: 0.08999999,
      fill: "url(#O)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.475 48.024q-.009.012-.019.024.01-.012.019-.024",
    style: {
      fill: "url(#P)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.212 110.415.152.009a2.8 2.8 0 0 0-.578-.386c-.651-.345-3.476-2.212-4.349-2.802-.872-.59-2.399-1.583-3.072-1.376-.516.159-.442.367-.749.517-.308.146-.64.049-1.401-.357-.762-.404-1.327-.675-2.813-2.087-1.16-1.103 1.486-.11 1.486-.11s.577.244.32-.358c-.258-.602-1.561-2.173-2.789-3.439a19 19 0 0 1-2.268-2.766l-.528-.618.007-.154q-.025-.036-.049-.072s-1.745-3.146-1.561-4.302c0 0 .064-.772 1.156-1.105.761-.233.662.504 2.899.908 0 0 1.929.518 2.433-.883.502-1.401-.528-3.159-.528-3.159s-1.35-2.475-3.022-2.568c-.885-.049-.645.544-1.979.861 0 0-1.782.171-2.346-.897-.684-1.293-.969-2.764-.946-3.747.021-.932.051-1.007.111-1.278.042-.192.179-.542.237-1.05l-.125-.622.19-.466q.003-.362-.019-.774c-.085-1.547-.198-3.93-.407-5.32-.208-1.389-.59-3.538-1.855-3.601 0 0-.625-.048-1.522.825-.824.797-1.569-.66-1.61-1.549-.049-1.044.122-2.1.381-2.604.258-.504.97-.528 1.105-.517s.517.159.972.442 1.08.284 1.45-.086c.368-.367.883-.798 1.093-2.42s.209-3.305.012-5.32l-.209-.451 1.248-.269c-.001-.016-.02-.118-.03-.18v-.004l-.007-.046-.001-.007-.008-.053-.001-.003-.009-.058v-.001l-.01-.063-.001-.008-.008-.062-.003-.015-.008-.065-.002-.013-.01-.071v-.005l-.01-.071-.003-.015-.009-.074-.002-.019-.01-.076-.002-.017q-.004-.04-.01-.081l-.002-.013-.009-.077-.002-.014q-.004-.043-.01-.084l-.002-.019-.01-.084-.002-.021-.009-.087-.002-.017q-.004-.045-.009-.088v-.008q-.005-.046-.009-.093l-.001-.018-.007-.092-.001-.02q-.005-.046-.008-.092l-.001-.018-.006-.095-.001-.009-.006-.093-.001-.016-.005-.093-.001-.02-.003-.092-.001-.019-.004-.093v-.013l-.002-.092v-.008l-.001-.094v-.107l.001-.017.001-.089v-.014l.003-.092c.048-1.159.272-1.632.272-1.632l.053-.153s.429-1.359 1.075-2.291l-.012.023s.416-.688 1.147-.759c.731-.073.935.145 1.277.186l.107.012.034.004.07.006q.019.002.038.003l.06.004.038.003q.029 0 .054.003h.039l.051.002.035.002h.126l.03-.001.043-.001.028-.002.042-.002.024-.001a1 1 0 0 0 .063-.006l.041-.003.018-.002.042-.007.012-.001.049-.008q.048-.01.091-.02l.002-.002.036-.009.008-.001.026-.009q.005 0 .009-.003l.024-.008.008-.003.02-.008.008-.003.019-.008.007-.004.017-.007.005-.004.015-.006.006-.004q.006-.003.012-.007l.004-.003.011-.007.004-.003.01-.007.002-.003q.005-.002.008-.007h.002l.007-.007.001-.001.006-.006.003-.003.002-.002.003-.004q.004-.003.003-.004c.306-.225.552-.481.743-.722l.037-.047.008-.011.035-.045.007-.01.035-.047.001-.001q.054-.076.102-.148l.003-.006q.014-.021.028-.041.003-.005.007-.011l.023-.039.008-.012.023-.039.001-.002q.024-.038.043-.074l.007-.011.015-.028.011-.018.013-.023.01-.021.011-.021.011-.02q.004-.009.009-.017c.062-.121.091-.193.091-.193.553-1.359.048-2.734-.196-3.003-.298-.329-.969-.822-.969-.822s-.397-.333-1.006-.024c-.485.246-.662.187-.662.187-.023-.464.139-1.334.457-2.108.318-.772 1.001-2.099 1.001-2.099s.976-1.669 1.367-2.692c.39-1.026.387-1.807.387-1.807s-.745-.947-.852-1.094a.7.7 0 0 0-.254-.208 2 2 0 0 1-.322.096l.158-.13s.395-.458.999-.311a1.47 1.47 0 0 0 1.043-.118c.941-.711 1.541-2.037 1.541-2.037l.92-1.86-.769-1.245s-.122-.026-.912.242c0 0-.72 1.774-1.607 2.876 0 0-.348.514-.618.387a1.4 1.4 0 0 0-.848-.079c-.262.055-1.077.325-1.815 1.316-.736.991-.823 1.735-.427 1.957s.974-.071 1.323-.379c.349-.31.594-.452.705-.438.11.018.087.294.063.382-.024.087-.143 1.271-1.513 3.645a37 37 0 0 0-.996 1.906l.566.416-.93.469c-.247.706-.564 1.812-.439 2.431.19.942 1.079.942 1.079.942s.578.025 1.252-.324c.673-.349.831 1.157.831 1.402 0 .246-.007 1.608-.95 2.275 0 0-.381.292-.918.292-.539 0-.889-.158-.889-.158s-.917-.253-1.481.078c-.562.334-1.235 1.023-1.768 2.022-.53.998-.973 2.781-.949 4.096.018 1.035.168 2.014.271 2.682l.622.405-.506.58c.074 1.058.157 3.133.144 3.828-.016.848-.143 2.646-1.039 3.067 0 0-.301.159-.808-.221-.507-.381-1.054-.397-1.276-.405-.222-.007-1.197.151-1.576 1.221-.38 1.066-.349 2.504-.27 3.351.08.847.816 2.29 1.743 2.29 0 0 .452.032.983-.515.529-.546.84-.593 1.077-.586.238.008.698.253.999 2.654.286 2.277.407 4.14.385 6.212l.564.365-.706.715c-.039.186-.083.389-.132.583-.158.634-.174 1.27-.023 2.394.15 1.126.755 3.465 1.634 4.075 1.167.811 1.929.798 2.716.737.785-.062 1.327-.663 1.327-.663s.308-.318.638-.222c.332.099 1.254.615 1.917 1.942.664 1.327.811 2.788-.295 3.048-1.106.257-3.01-.787-3.01-.787s-1.081-.603-1.965.062c-.885.664-.91 1.682-.467 2.936.243.688.728 1.805 1.409 2.969l.672.281-.18.513c.458.696.983 1.378 1.563 1.962 0 0 2.297 2.543 3.576 4.153 0 0 .074.146-.147.013-.222-.136-1.18-.579-1.696-.528-.517.049-.419.367-.419.367s.222 1.167 3.736 3.135c0 0 1.266.712 2.064.712 0 0 .258.036.577-.32.322-.356.419-.318.64-.245.221.072.516.233 1.622 1.032 1.107.798 3.256 2.026 4.029 2.544.773.517.739.613.578.982-.159.369.553.577.553.577s1.769.798 2.728.787c.958-.013 1.363-.11 1.953.011.589.123 1.192.271 1.253.321.062.049-.294.035-.294.035s-2.2-.257-2.323-.195.013.171.922.404v.006q1.741.302 3.523.475c-.455-.056-2.347-.301-3.561-.665 0 0-.122-.072.161-.011.282.061 1.88.208 2.297.146s-.086-.258-.086-.258-.836-.393-2.691-.541c0 0-.748-.049-1.4.013s-1.314-.245-1.314-.245-.958-.296-.726-.602a.44.44 0 0 0 .06-.467z",
    style: {
      opacity: 0.54000005,
      fill: "url(#Q)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.713 107.111-.409.604c.09.611-.096.814-.234 1.042-.147.241-.55.551-.349 1.102.201.55 1.569.375 2.361.134a45 45 0 0 0 1.986-.645c.524-.187.671.08.671.08s.229.161-.536.564c-.766.402-2.176.59-2.846.67-.672.081-.47-.04-1.477.309s-.066.658-.066.658c2.267.591 3.905.107 3.905.107l.308-.089q.375-.111.746-.228c-1.885.425-3.098.139-3.483.088-.402-.054-.726-.135-.819-.336s.443-.188.443-.188 1.569-.174 3.02-.644c1.45-.471 1.799-.914 1.744-1.249-.053-.335-.79-.31-1.664-.027-.872.283-2.174.699-2.481.766-.31.066-.645.054-.753-.134-.107-.189-.202-.496.134-.846.337-.349.376-.646.376-.646.051-.236.053-.488.02-.745zl.507-.11c-.277-1.047-.979-2.066-1.191-2.402-.294-.471-.779-.738-2.228-.498-1.449.242-3.154.966-3.154.966s-1.758.928-3.073.753c-1.316-.175-1.586-1.503-1.572-1.919.014-.418.283-.779.967-1.048.685-.269 2.296-.631 4.644-.751 2.349-.121 3.222-1.651 3.222-1.651.308-.443.859-1.437-.456-2.175s-1.343-.551-1.974-1.033c-.631-.483-1.315-1.074-1.584-1.893a4 4 0 0 0-.101-.273l-.788-.518.383-.347c-.317-.624-.648-1.185-.648-1.185s-1.194-1.771-.229-3.449c.967-1.679 2.55-2.188 2.55-2.188s1.397-.308 2.792.014c1.319.304 1.986-.202 1.986-.202s.806-.349 1.047-1.958c.243-1.611-.013-4.605-2.16-5.196-2.147-.589-3.287.524-3.287.524s-1.156 1.275-1.53 1.463c-.377.188-.954.523-.954.523s-.808.483-1.355.605c-.363.08-1.666-1.65-1.798-2.981-.124-1.227-.374-2.225-.285-4.748l-.452-.587.5-.496c.094-2.794-.389-4.766-1.106-6.019-.752-1.315-1.974-2.013-2.577-2.308-.604-.296-2-.43-2.953-.08-.953.348-1.154.631-1.503 1.235-.35.604-.779.564-.779.564s-1.329.04-1.758-1.987c-.602-2.841.335-3.759.335-3.759s.296-.443 1.275-.576c.98-.134 1.611.107 2.363.294.751.188 1.314.107 2.254-.349.939-.457 1.343-1.208 1.154-2.551-.182-1.298-.238-1.623-1.382-5.556L62 52.83l.543-.539c-1.106-3.986-1.172-6.485-1.172-6.485-.099-.91.046-1.203.557-1.434.537-.241 1.04-.163 1.802-.114s1.327-.074 1.72-.295c.394-.221 1.473-.81 1.401-2.014-.074-1.204-1.033-2.63-1.819-3.121-.785-.492-1.819-.295-2.383.122-.565.419-.787.959-1.131 1.131-.344.17-.834.564-1.351.442-.516-.123-.541-1.277-.762-2.58-.143-.845-.253-1.501-.315-1.853l-.632-.237c.041.519.498 3.078.498 3.078s.208 1.271.287 1.577c.08.306.293.978.293.978s.086.339.425.498c.34.16.98.223 1.624-.03.645-.252.825-.533 1.117-.874.293-.339.399-.459.399-.459s.618-.579 1.377-.319c.758.259 1.21 1.144 1.21 1.144l.026.055s.376.616.365 1.182v-.053s-.021.28-.65.762c-.629.483-1.142.446-1.563.412-.422-.037-.62-.067-.742-.042l-.67.036c-.732.103-1.14.38-1.14.38-1.677.991.686 8.652.686 8.652l-.257.571s.479 1.912.842 3.147c.362 1.235.523 2.456.577 2.711s.041.71-.295.979-1.154.497-1.328.523-.498-.04-.927-.188c-.431-.147-.859-.174-.859-.174s-1.034-.175-2.134.161c-1.101.335-1.934 1.462-2.001 2.872s-.053 2.122.498 3.37c.55 1.248 1.544 1.96 2.295 1.973.753.013 1.369-.375 1.799-.979.428-.606.55-.7.55-.7.51-.281 1.811-.403 2.469-.16.659.241 1.87 1 2.537 2.496.539 1.209.708 2.562.679 4.996l.544.418-.568.655-.024.708c-.133 3.611.671 5.463.671 5.463.457.994.953 1.704 1.625 2.161.67.456 1.584.146 1.879 0 .295-.149 1.113-.524 1.812-.967.697-.443.672-.631 1.517-1.41.845-.777 1.934-.563 1.934-.563s1.032.027 1.623 1.222.471 2.899.321 3.517c-.147.617-.415 1.02-.993.913a18 18 0 0 0-1.878-.216c-.35-.012-1.333-.045-2.229.188-.872.229-2.054.859-3.18 2.686-.875 1.415-.444 2.806-.243 3.355.157.43.589 1.029.97 1.766l.706.235-.327.612c.371.897.654 1.392 1.216 2.004.604.657 1.557 1.166 2.684 1.597 1.129.43.617 1.194.617 1.194-.645 1.396-2.563 1.45-3.127 1.517s-1.744.175-2.847.418c-1.1.241-2.134.388-2.751 1.099-.616.712-.375 1.449-.012 2.229.361.777 1.329 1.193 2.657 1.14s2.188-.441 2.994-.791c.805-.349 2.2-.753 2.616-.872.417-.12.98-.362 1.396.242.45.653.926 1.581 1.143 2.283z",
    style: {
      opacity: 0.3,
      fill: "url(#R)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.253 74.509s.323-3.015.426-4.092q.023-.241.042-.478l-.09-.224c-.428 5.417-.873 7.198-.873 7.198l.03-.093q.266-1.144.473-2.311zM104.66 38.566l.306.384.26.466c.952 1.535 2.65 4.001 2.65 4.001s.69.893.844.902-.077-.691-.077-.691-.25-.912.48.278c.681 1.109 1.123 2.198 1.229 2.534.106.337.038.383.038.383s-.134.067-.134.308c0 .47.461 1.545.461 1.545s1.439 3.657 1.929 5.182c.49 1.529 1.056 4.069 1.056 4.069s.172.749.192 1.094c.018.345-.059.355-.212.173-.153-.183-.307-.067-.307-.067s-.163.067-.163.72c0 .652.079 2.186.202 3.368.143 1.402.574 1.987.574 1.987s.385.576.49-.537c.09-.958.173-.212.173-.212.182 1.45.057 4.233.029 4.616q-.025.306-.046.596l.123-.206c.189-2.767.056-4.992.056-4.992s-.134-1.233-.28-1.222c-.144.01-.196.653-.196.653s-.062.435-.146.424c-.082-.01-.343.021-.528-1.315-.186-1.338-.145-2.747-.145-2.747s-.042-.145.042-.176.177.093.177.093.123.176.268.03c.146-.143.176-.579-.28-2.869a35 35 0 0 0-.938-3.57l-.274-.31-.051-.669s-.289-.85-.963-2.55-.788-2.29-.788-2.29-.042-.186.063-.218c.104-.03.083-.166.083-.166s-.011-.228-.259-.922c-.249-.695-.396-1.194-1.265-2.664-.809-1.368-1.047-1.451-1.047-1.451s-.395-.218-.104.55c.29.767-.072.217-.072.217-.86-1.097-2.643-3.999-2.643-3.999l-.501-.348-.472-1.174-.013.009M21.079 57.306l-.17.345c-.44 2.324-.582 4.783-.577 4.946.009.194-.033.197-.07.166-.039-.032.028-.149-.044-.149-.074 0-.101.197-.101.197l-.001-.005q-.028.402-.049.803l.014-.003c.064-.091.091-.026.091-.026s-.027.117.09.052c.118-.065.196-1.285.196-1.285s.013-2.619.779-5.719C22 53.529 22.43 52.66 22.43 52.66s.143-.39.129-.078c-.013.311.182.337.182.337.35-.051.765-1.049 1.181-2.323.414-1.27.622-2.412.622-2.515s-.051-.181-.142-.129-.117.013-.117.013c-.013-.194.336-1.05.336-1.05 1.168-2.983 2.891-5.304 2.891-5.304l.084-.47c-.152.237-.251.39-.392.616-.052.083-.039.276-.001.298-.187.178-.34.326-.443.425-2.522 4.167-2.85 6.107-2.85 6.107-.015.199.004.29.104.285.061-.003.234-.325.108.33-.084.436-.488 1.591-.646 2.061-.159.471-.334.792-.461.769-.126-.023-.126-.218-.126-.218s-.039-.509-.371.228-.664 1.732-1.327 4.332q-.044.174-.086.354zM24.148 85.188c-.14-.376-.246-.673-.167-.542.079.133.184.403.43.674.245.272.412-.209-.579-2.891s-1.261-2.832-1.306-2.883c-.043-.053-.201-.221-.156.156.042.377.017.613-.475-1.069s-.928-4.512-.955-4.74c-.025-.228-.158-1.657-.368-3.348-.211-1.69-.229-3.487-.193-3.987s-.062-.771-.115-.78c-.052-.008-.087.044-.122.264-.035.219-.009.368-.062.359s-.071-.439-.071-.439h-.007v.14l.002.484.036.374c.031.556.12.33.126.229s.028-.306.028-.306.095-.824.078.018.22 4.25.22 4.25q.026.332.063.679l.059.085-.039.098c.247 2.259.741 4.738.741 4.738.472 2.252 1.034 3.583 1.218 3.959.185.378.22.079.159-.253-.062-.333.508.64.813 1.56.309.922.518 1.692.518 1.692s.237.728.132.771-.272-.272-.272-.272-.44-.779-.255-.21c.371 1.147 1.49 3.56 1.49 3.56l1.301 2.302c-.93-1.682-2.141-4.32-2.272-4.672M26.421 89.858q.096.175.188.335zM38.942 29.525c-.198.319-.225.479-.225.479s.104-.11.17-.221c.065-.11.055-.258.055-.258M35.676 32.038c-.388.045-.631.233-.631.233s.326-.056.631-.233M97.895 31.421s.229-.028.321.018c.093.046.063-.147.063-.147s-.268-.378-.3-.518c-.3-.083-.571-.093-.571-.093l-.027.032c-.009.07-.034.175-.011.277-.001.001.442.339.525.431M101.138 34.188l.088-.142-.206-.633-.018-.033c-.007.062-.046.116-.16.107 0 0-.092-.028-.01.184.054.134.184.349.306.517",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.253 74.509s.323-3.015.426-4.092q.023-.241.042-.478l-.09-.224c-.428 5.417-.873 7.198-.873 7.198l.03-.093q.266-1.144.473-2.311z",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.235 105.591s.62-.608.501-.701-.58.239-.58.239-.068.056-.172.131l.366-.235s-.036.223-.332.518c0 0-.086.086-.241.231-.89.873-2.221 1.862-2.221 1.862l.37-.198c1.228-.753 2.309-1.847 2.309-1.847",
    style: {
      opacity: 0.5,
      fill: "url(#S)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.943 63.835.475-.83-.118-1.553s-.08-.832-.528-2.124c-.913-2.634-1.808-3.84-1.808-3.84s-.552-1.228-1.835-1.228c-1.239 0-1.332 1.135-1.332 1.135s-.291.897-.765 1.175c-.465.27-1.836 1.068-2.562.276-.877-.956-1.358-2.072-1.451-3.141s.342-1.504.342-1.504.093-.276 1.505-.276c1.585 0 1.875-.489 1.875-.489s.303-.276.277-.897-.265-1.953-.727-2.796c-.303-.555-.984-1.431-1.568-2.106l-.901-.166.142-.651c-.521-.479-3.227-3.688-3.756-4.44-.526-.753-.606-.925-.698-1.176s.157-.817.383-1.081c.223-.264.486-.318 1.028-.198.541.119.896.355 1.756.079.857-.277.896-.924.963-1.583s-.726-2.058-1.358-2.731c-.635-.672-1.531-.779-2.151-.738-.62.039-.977.487-1.334.686-.355.199-1.027.396-1.331.265-.304-.133-.767-.265-1.28-1.175a53 53 0 0 1-.912-1.693l-.667-.07v.011s.59 1.541 1.521 2.619 2.11.856 2.11.856.765-.083 1.429-.719c.662-.636 1.64-.138 1.888.037s.793.848 1.374 1.982c.58 1.133-.332 1.917-.332 1.917s-.516.498-1.575.082c-1.061-.413-1.688.241-1.852.572-.167.333-.472.922.073 1.612.543.691 2.958 3.981 4.579 5.538 1.622 1.558 2.156 2.839 2.496 4.045.341 1.208.074 1.769-.486 1.88-.563.11-1.07.019-1.944.174-.877.158-1.254.341-1.438 1.54-.185 1.198.524 3.142 1.557 4.063s2.175.359 2.57.212c.397-.148 1.259-.609 1.566-1.889.175-.729.793-.672.793-.672s.524-.066.792.109c.268.177.591.489 1.308 1.742.72 1.253 1.355 2.931 1.604 4.414.247 1.483.064 1.694.303 2.745s1.005 3.023 1.365 3.796c.358.774.728 1.548.922 1.963.192.415.496.728 1.345.747.848.018 1.188-.212 1.437-.617s.571-1.014.663-1.226.434-.848 1.069-.95c.637-.101 1.641.009 1.963 1.116.291.998.709 2.442-.146 4.192-.608 1.244-1.052.802-2.286.885 0 0-1.086-.009-1.659.857-.57.867-.387 2.432-.267 3.612.12 1.178.921 2.902 1.511 3.317s.801.792 1.005 1.17c.202.377.498 1.123.202 3.086-.294 1.964-.912 3.484-1.741 4.212l-.066.059a5 5 0 0 1-.203.188c-.5.484-.346.507-.827.739-.553.269-.922.194-1.824.341-.903.148-1.475.305-1.945.765-.469.461-1.158 1.313-.912 2.968.138.919 1.229.545 2.076.104a2.5 2.5 0 0 1-.743.229c-.963.107-.924-.884-.858-1.317.065-.437.291-1.439.99-1.835s1.675-.383 2.361-.476c.688-.093 1.003-.29 1.003-.29s1.122-.712 1.86-1.913c.739-1.201 1.399-3.141 1.478-5.067s-.765-2.705-1.029-3.049c-.264-.342-.744-.189-1.332-1.609-.673-1.623-.752-2.968-.699-3.8.052-.831.25-1.148.633-1.503.383-.357 2.071-.198 2.071-.198s.831.171 1.57-1.056c.738-1.228.687-3.233.448-4.235-.236-1.003-.58-1.875-1.952-2.02-1.372-.144-1.992 1.544-1.992 1.544s-.277.646-.567 1.017c-.291.368-1.082.265-1.082.265-.345-.041-.766.092-1.175-.754-.409-.844-1.346-3.062-1.346-3.062a13 13 0 0 1-.641-1.914z",
    style: {
      opacity: 0.5,
      fill: "url(#T)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.443 100.726.783-.441c.735-1.146 1.602-2.151 2.264-2.888.805-.897 1.768-2.351 1.768-2.351s.777-1.333.593-1.663c-.121-.216-.761.154-1.185.434q.104-.06.185-.099s.755-.45.599.064c-.156.518-.543 1.208-1.281 2.213 0 0-.356.519-.723.891-.345.402-.591.656-.591.656q0-.002-.05.046a31 31 0 0 0-1.55 1.93l-.049.068q-.41.582-.703 1.044l-.035.061zc-.228.363-.4.662-.525.893l-.034.08s-.239.628-.369 1.004c-.128.378-.11.508-.579.581-.47.074-.258-.047-.95.185 0 0-.377.185-.873.532l-.076.06a13 13 0 0 0-1.429 1.336q-.07.089-.137.182s-.147.158.047.176a2.2 2.2 0 0 0 .939-.157l.081-.051c-.173.093-.347.16-.477.15-.37-.026.448-.806.448-.806s.845-.948 1.649-1.094.949-.345 1.346-.647c.396-.304.462-.633 1.267-2.099q.045-.081.091-.162z",
    style: {
      opacity: 0.5,
      fill: "url(#U)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.933 94.559.381-.351c-.316-.623-.646-1.181-.646-1.181s-1.195-1.771-.229-3.449c.966-1.679 2.551-2.188 2.551-2.188s1.396-.308 2.791.014c1.32.304 1.986-.202 1.986-.202s.807-.35 1.048-1.959c.241-1.61-.013-4.604-2.161-5.195-2.147-.59-3.287.524-3.287.524s-1.156 1.275-1.53 1.463c-.377.188-.955.522-.955.522s-.807.484-1.354.605c-.362.081-1.665-1.651-1.798-2.98-.124-1.226-.373-2.222-.284-4.737v-.016l-.453-.584.5-.492c.095-2.795-.39-4.768-1.107-6.021-.75-1.317-1.973-2.015-2.577-2.31s-1.999-.429-2.952-.08-1.153.63-1.503 1.234c-.35.605-.778.564-.778.564s-1.329.041-1.76-1.986c-.6-2.841.336-3.76.336-3.76s.296-.442 1.275-.576c.98-.134 1.611.107 2.362.296.752.186 1.314.106 2.255-.349.94-.456 1.343-1.209 1.155-2.55-.182-1.302-.231-1.609-1.382-5.558l-.814-.428.542-.539c-1.101-3.978-1.171-6.485-1.171-6.485-.098-.908.046-1.201.557-1.432.537-.243 1.041-.165 1.802-.116.763.048 1.328-.074 1.721-.295.394-.22 1.474-.81 1.4-2.015-.073-1.204-1.032-2.629-1.818-3.12s-1.818-.296-2.384.123c-.565.417-.786.958-1.13 1.129s-.834.566-1.351.442c-.516-.123-.541-1.278-.762-2.58a345 345 0 0 0-.318-1.853l-.628-.237c.04.519.498 3.078.498 3.078l.274 1.513v.018l.012.047c.018.073.046.168.076.269.106.2.345.424.878.467a2.43 2.43 0 0 0 1.887-.66c.236-.223.801-.849.801-.849s.307-.589 1.168-.46c.859.13 1.153.72 1.307.944.155.225 1.462 1.827.626 2.665l-.142.135a3 3 0 0 1-.415.372c-.629.482-1.142.448-1.563.412s-.619-.065-.741-.041l-.671.036c-.733.103-1.14.38-1.14.38-1.677.992.685 8.651.685 8.651s.625 1.891.906 2.776.462 1.513.737 3.04-.215 1.949-.489 2.097-.917.529-1.648.563c-.729.032-.957-.342-2.209-.402-1.253-.061-2.092.321-2.479.844-.389.522-.851 1.735-.629 3.167.221 1.435.469 1.923 1.017 2.56.55.635 1.085.904 1.843.649.737-.248.711-.704 1.092-1.084.482-.484.797-.738 1.922-.765s1.843.268 2.417.73c.576.462 1.801 1.533 2.137 3.127.335 1.595.395 2.111.395 3.423s-.094 2.773-.06 4.081c.034 1.305.174 2.645.537 3.535.36.89.864 1.634 1.305 2.03s.836.407 1.279.234c.442-.174 1.406-.717 2.21-1.233s.743-.924 1.468-1.399a3.14 3.14 0 0 1 2.29-.456c.617.107 1.561.589 1.949 1.761.389 1.173.335 2.493.335 2.493s.034 1.104-.415 1.748-1.187.575-1.514.509a13 13 0 0 0-1.018-.127s-1.354-.154-2.386.088c-1.031.24-1.936 1.01-2.545 1.767-.609.758-.878 1.462-.918 2.01a4.03 4.03 0 0 0 .597 2.397c.57.912.663 1.333 1.312 2.634.65 1.299 2.005 2.022 2.051 2.055.047.035 1.293.49 1.761.884.469.396.517.771.383 1.125-.134.356-.408 1.02-1.494 1.494-1.085.477-2.411.489-3.256.577-.844.086-2.471.308-3.443.776s-.904 1.354-.904 1.354-.026 1.448 1.246 1.85 2.459 0 2.981-.222 1.386-.544 1.386-.544 1.668-.588 2.564-.789c.898-.201 1.428-.301 2.039.776.608 1.079.943 1.756 1.004 2.445.061.69-.195 1.071-.43 1.333-.233.261-.2.428-.2.428-.1.813 1.099.71 1.099.71q.002.002.104-.016c-.242.022-.465-.018-.55-.164-.107-.189-.201-.496.134-.845.337-.349.377-.646.377-.646.282-1.343-.967-3.141-1.262-3.61s-.779-.737-2.228-.496-3.154.966-3.154.966-1.76.928-3.074.752c-1.316-.175-1.585-1.503-1.571-1.919s.283-.78.967-1.047c.684-.27 2.295-.632 4.643-.752 2.351-.12 3.222-1.65 3.222-1.65.309-.444.86-1.437-.456-2.177-1.315-.736-1.343-.549-1.973-1.031-.631-.485-1.315-1.074-1.585-1.894a4 4 0 0 0-.101-.272z",
    style: {
      opacity: 0.92000002,
      fill: "url(#V)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.344 39.296c.951 1.536 2.649 4.001 2.649 4.001s.238.309.466.564l.008-.01c.01-.349-.046-.532-.055-.578l-.084-.256c-.021-.341.406.089.571.268-.465-.702-.616-.755-.616-.755s-.393-.218-.103.55c.291.767-.071.217-.071.217-.86-1.097-2.643-3.999-2.643-3.999l-.515-.357zM114.229 74.685l.032-.176h-.008l.01-.083q-.02.135-.034.259M113.56 60.085c.083-.031.177.093.177.093s.124.176.269.03c.099-.097.144-.328.023-1.171a1.3 1.3 0 0 1-.127.55c-.129.276-.293.018-.412-.075-.12-.091-.156.065-.156.065l-.004.151c0 .652.081 2.186.202 3.369.058.564.162.998.268 1.312l.038.071c.083.138.176.32.285.238.11-.083.257-.542.257-.542l.119-.551c.178.105.271.493.317.896l-.003-.052s-.134-1.233-.28-1.224c-.145.01-.195.653-.195.653s-.063.436-.146.424c-.083-.01-.343.021-.528-1.315-.187-1.338-.146-2.747-.146-2.747s-.041-.144.042-.175M112.512 53.459l.277.318c.445 1.391.928 3.58 1.017 3.972q-.037-.193-.081-.411a35 35 0 0 0-.938-3.57zl-.046-.654-.006-.015s-.288-.85-.962-2.55c-.675-1.699-.789-2.29-.789-2.29s-.041-.186.063-.218c.103-.03.083-.166.083-.166s-.011-.228-.259-.922c-.168-.469-.29-.849-.617-1.497.261.545.43.98.49 1.173l.026.064s.092.138.064.514c-.028.375-.138.421-.138.421l.022.13c.13.501.389 1.105.389 1.105s.994 2.524 1.63 4.229z",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.656 112.119c.874.165 1.605.334 1.76.369-.31-.102-.887-.26-1.76-.369",
    style: {
      fill: "url(#W)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.624 96.641.007-.154-.049-.074s-1.745-3.145-1.561-4.3c0 0 .064-.772 1.156-1.105.761-.233.662.502 2.899.908 0 0 1.929.518 2.433-.883.502-1.401-.528-3.159-.528-3.159s-1.35-2.475-3.022-2.568c-.885-.05-.645.544-1.979.861 0 0-1.782.171-2.346-.897-.684-1.293-.946-2.764-.946-3.747s.042-.932.117-1.309c.042-.203.173-.51.231-1.015l-.125-.628.19-.465q.004-.361-.02-.774c-.086-1.547-.197-3.931-.406-5.32-.208-1.389-.59-3.539-1.855-3.601 0 0-.625-.048-1.524.825-.822.797-1.567-.66-1.608-1.549-.049-1.044.122-2.101.381-2.604.258-.504.97-.528 1.105-.516.135.011.517.159.971.442.455.283 1.081.283 1.451-.086.368-.368.883-.798 1.093-2.42s.209-3.305.012-5.32l-.209-.452 1.248-.268c-.001-.015-.019-.117-.03-.182l-.001-.002q-.002-.023-.007-.048v-.005l-.008-.053-.001-.003-.009-.058v-.001l-.01-.063-.001-.007-.008-.063-.003-.014-.01-.078-.011-.071v-.005l-.011-.071-.002-.016-.009-.073-.003-.019-.009-.076-.003-.018-.009-.081-.002-.012q-.004-.04-.009-.077l-.002-.015-.01-.085-.002-.018-.01-.084-.002-.021-.009-.088-.002-.016q-.004-.045-.009-.088l-.001-.008q-.003-.047-.008-.093l-.001-.018-.007-.092-.002-.02-.007-.092-.001-.019-.006-.094-.001-.008-.007-.093v-.016l-.005-.093-.001-.021-.004-.091v-.019l-.004-.094v-.012l-.002-.092v-.008l-.001-.095v-.123l.001-.09.001-.013.003-.093c.048-1.158.271-1.631.271-1.631l.054-.154s.429-1.359 1.074-2.29l-.011.023s.416-.688 1.147-.761c.731-.071.934.147 1.277.188l.107.012.034.004q.037.002.069.006l.039.003.06.004.038.002.054.002q.018.003.038.002l.051.002.036.001.048.001h.032l.046-.001.03-.001.043-.001.028-.001.042-.002.024-.001.041-.004.021-.002.041-.004.018-.002.042-.006.013-.001.049-.008.091-.02q0-.001.002-.002l.036-.009.007-.001.027-.009.009-.004.024-.007.008-.003.02-.008.008-.004q.01-.003.019-.008l.007-.003.017-.007.005-.004.014-.007q.003-.002.007-.003l.012-.008q.001 0 .004-.002l.011-.007.004-.003.009-.008q.003 0 .002-.002l.01-.007.001-.001q.005-.003.008-.007h.001l.006-.007.003-.002.002-.002.003-.004.003-.004c.306-.225.551-.481.743-.722l.037-.047.008-.011.035-.046q.004-.004.007-.01l.035-.047h.001l.102-.148q0-.004.003-.007.014-.02.028-.041l.007-.01.023-.039.008-.012q.012-.02.022-.039l.002-.002.043-.074.006-.012q.008-.014.016-.027l.011-.018.013-.023.01-.021.011-.022q.005-.01.011-.019l.009-.019c.062-.119.091-.191.091-.191.552-1.359.048-2.735-.196-3.004-.298-.328-.969-.821-.969-.821s-.268-.225-.7-.134c.325-.046.737.085.9.52.258.684.35 1.244.198 2.17 0 0-.243 1.292-1.289 2.08-1.048.79-1.792.09-2.688.121-.896.03-1.412.653-1.685 1.078s-1.32 2.049-1.229 4.72c.09 2.672.271 4.007.303 5.177.03 1.123.166 3.704-.592 4.917-.759 1.214-1.517.606-2.049.288s-1.139-.228-1.624.122c-.486.349-.776 1.047-.79 3.096-.015 2.202 1.427 2.428 1.427 2.428s.273.136.88-.5c0 0 .607-.638 1.168-.562.562.076.926.667 1.169 1.684s.741 5.236.668 8.075c-.032 1.184-.578 1.199-.335 3.37 0 0 .38 2.915 1.305 3.809.927.897 2.216.729 2.521.699.302-.03.652-.242.652-.242s.288-.184.5-.349c.214-.168.486-.396.941-.259.456.136 1.533.835 2.382 2.396.852 1.564.462 3.093-.242 3.279-.622.168-.79.213-1.836-.045-1.047-.259-1.352-.53-1.823-.714s-.972-.243-1.441.108c-.471.347-1.253.983-.32 3.093.895 2.025 1.576 3.538 3.277 5.239a20 20 0 0 1-1.33-1.743z",
    style: {
      fill: "url(#X)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.593 33.729-.047.023z",
    style: {
      fill: "url(#Y)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.516 113.344.365.037a29 29 0 0 1-.523-.069z",
    style: {
      fill: "url(#Z)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.078 31.961c-.605.335-.652-.015-1.063.015-.409.031-.956.198-1.486.972-.532.774-.546 1.761.303 1.32 0 0 .406-.399.76-.539.075-.04.223-.118.378-.162l.134-.109s.395-.457.999-.31a1.48 1.48 0 0 0 1.043-.12c.941-.709 1.542-2.035 1.542-2.035l.919-1.861-.769-1.245s-.65 1.387-1.288 2.357c-.636.975-.592 1.235-1.472 1.717",
    style: {
      fill: "url(#aa)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.149 42.025s-.395 1.76 1.077 1.487l.021-.006a.2.2 0 0 1-.083-.006c-.024-.463.139-1.334.456-2.106.318-.773 1.001-2.1 1.001-2.1s.976-1.668 1.367-2.692c.391-1.026.387-1.806.387-1.806s-.745-.949-.852-1.096c-.107-.146-.254-.208-.254-.208l-.136.048c.107-.007.206.019.264.106.198.289-.364 1.897-.364 1.897s-.486 1.153-1.442 2.822c-.956 1.671-1.442 3.66-1.442 3.66",
    style: {
      fill: "url(#ab)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.21 110.406.154.018a2.7 2.7 0 0 0-.463-.322c.171.105.456.334.291.619-.228.395-.045.426.456.804l.056.031c-.145-.1-.235-.218-.145-.337a.44.44 0 0 0 .061-.465z",
    style: {
      fill: "url(#ac)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.402 103.933c-1.16-1.103 1.486-.11 1.486-.11s.577.244.32-.358c-.229-.532-1.279-1.828-2.369-2.998l.134.146s2.185 2.534 2.034 2.762c-.153.229-1.033-.303-1.033-.303s-1.305-.502-1.123.121c.133.457.987 1.185 1.431 1.538-.253-.217-.543-.48-.88-.798",
    style: {
      fill: "url(#ad)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.768 105.78c.395.238.842.477 1.272.629 0 0 .774.273 1.246-.106.469-.377.469-.56 1.153-.227 0 0 1.293.649 2.219 1.346.914.685 3.314 2.175 4.096 2.599-.712-.388-3.458-2.203-4.316-2.784-.872-.59-2.398-1.583-3.072-1.375-.516.159-.441.368-.749.516-.308.147-.64.05-1.401-.356-.155-.084-.301-.161-.448-.242",
    style: {
      fill: "url(#ae)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.81 112.037c.345.098.626.056.733.033-.632.038-1.258-.249-1.258-.249s-.063-.02-.153-.055c.222.103.479.213.678.271",
    style: {
      fill: "url(#af)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9 112.709s-1.252-.152-1.807-.152c0 0-.034.06.21.147-.02-.018-.029-.045.176 0 .283.062 1.88.209 2.297.147.417-.063-.085-.258-.085-.258s-.082-.039-.249-.095c-.3.241-.542.211-.542.211",
    style: {
      fill: "url(#ag)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.981 84.646c.079.133.184.403.43.674.136.151.248.069.151-.49-.236-.168-.379-.298-.432-.346-.105-.012-.245-.276-.245-.276s-.439-.779-.255-.21c.371 1.147 1.49 3.56 1.49 3.56l1.301 2.302c-.931-1.681-2.142-4.317-2.273-4.67-.14-.377-.246-.674-.167-.544M21.079 57.306l.03-.599q.038-.169.081-.336c.663-2.598.996-3.594 1.327-4.331.332-.737.371-.228.371-.228s0 .195.127.218c.126.022.302-.298.46-.769.159-.47.562-1.625.646-2.061.126-.655-.048-.334-.107-.33-.101.005-.118-.085-.105-.285 0 0 .356-1.977 2.854-6.114l.438-.418c-.051-.048-.03-.247.001-.298q.19-.3.393-.616l-.084.47s-1.723 2.321-2.892 5.304c0 0-.318.778-.335 1.019-.023.143-.097.688.142.542l.061-.045a19 19 0 0 1-.566 2.166c-.268.818-.534 1.521-.784 1.935l-.002-.003c-.075.062-.091-.015-.136-.196-.045-.184-.105-.184-.105-.184-.167 0-.301.188-.382.335a1 1 0 0 0-.083.177s-.429.87-1.193 3.969c-.766 3.1-.779 5.719-.779 5.719s-.078 1.22-.196 1.285c-.117.065-.09-.052-.09-.052s-.042-.049-.106.042c0 0 .018-.708.041-.816 0 0 .038-.192.111-.192.072 0 .005.117.044.149.037.03.079.028.07-.166-.005-.164.137-2.624.578-4.949zM20.003 65.968v-.005s.017.202.039.332l-.003.009c.073.333.174.333.174.333.007-.089.081-.254.17-.427a3 3 0 0 1-.004.349c-.035.5-.018 2.297.194 3.987.21 1.691.342 3.12.367 3.348.027.228.464 3.058.955 4.74.265.9.393 1.253.45 1.327l.008.046s.09.169.324.298c0 0 .103-.09.104-.385l.053.1c-.077.244-.098.396-.098.396-.039-.04-.056-.03-.043.042.062.333.025.632-.158.254-.184-.376-.745-1.707-1.217-3.961 0 0-.495-2.477-.741-4.736l.039-.098-.06-.085a26 26 0 0 1-.063-.679s-.237-3.409-.22-4.25-.079-.018-.079-.018-.02.204-.027.306c-.007.101-.095.327-.126-.229.024.243-.038-.745-.038-.994M42.621 28.686l-.493-.701-.062-.061s-.122-.127-.835.035l-.103.021s.354-.088.157.178c-.198.266-.522.462-1.092 1.072s-.383.748-.01.622c.374-.129 1.107-.465 2.428-1.158zM41.162 27.974l-.033.006z",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.657 28.534c.289-.254.399-.451.423-.597l-.014-.013s-.122-.127-.835.035l-.07.014c.084-.014.283-.03.124.184-.198.266-.522.462-1.092 1.073s-.383.748-.01.621q.148-.051.373-.146c.134-.291.551-.692 1.101-1.171M97.408 30.681l-.187.219s.126.075.194.131l.02.011-.065-.052c-.022-.102.003-.208.012-.277zs.05.002.132.011z",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.914 110.987s1.57-.175 3.02-.645 1.8-.914 1.745-1.249c-.035-.223-.369-.285-.844-.222.253-.019.478.03.329.309a1.64 1.64 0 0 1-.804.729s-.247.177-.827.346c-.75.228-1.672.348-2.176.408-.645.077-.485-.031-1.364.271q-.033.02-.061.041c-.269.222.997.477.997.477s1.214.338 3.035.215l.063-.019q.374-.11.745-.228c-1.884.426-3.097.139-3.482.088-.403-.054-.726-.134-.819-.335-.094-.2.443-.186.443-.186",
    style: {
      fill: "#454545"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.606 30.962.668.07c1.33-.377 2.47-.723 2.47-.723s1.178-.381 1.771-.592c.592-.211 1.016-.292 1.543-.382a10 10 0 0 1 1.593-.122c.372.007.494.113.494.113s.155.122.228.251.69 1.762 2.77 1.868c2.079.105 2.105-1.021 1.924-1.364-.21-.398-.835-.804-.835-.804s-.838-.536-1.016-.788.033-.334.098-.35c.063-.017 2.266-.463 2.541-.567l.02-.018-.524-.162s-.11.125-.734.291c-.624.167-1.151.229-1.623.292-.471.063-.471.223-.471.223l-.818 1.31s-.027.097.041.284c.069.188.381.417.381.417s.535.395.924.651.366.347.366.347c-1.046.089-1.322-.045-1.747-.257-.415-.208-.706-.679-.858-1.012s-.486-.617-.486-.617c-.548-.313-1.581-.32-2.62-.14-1.04.181-2.475.659-2.724.756-.251.097-1.506.513-2.15.679-.646.167-1.138.333-1.532.438-.396.103-3.195.936-4.244 1.248-1.047.311-1.719.43-1.719.43-1.574.159-2.045-.125-2.045-.125-.276-.117-.243-.492-.243-.492l.008-1.068s-.027-.403-.334-.569c-.305-.167-.727-.235-1.483-.27-.755-.035-1.567.041-1.949.125-.38.084-1.109.292-1.643.887-.534.597-.449 1.062-.449 1.062s.033.637.082 1.109c.049.47.451.617.451.617s-.693.495-2.837 1.123c-2.058.604-3.43.721-3.43.721l.631.237s5.094-.946 6.659-2.437c0 0 .581-.273.018-.82-.565-.545-.836-.709-.836-.709s-.382-.208.018-.718.86-.741 1.259-.869 1.633-.233 2.725-.087c0 0 .458.038.427.38-.033.341-.081.812-.073.958.007.147.024.48.373.787.351.31 1.023.422 1.023.422s1.17.212 2.647-.202 3.392-1.062 5.058-1.517z",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.783 33.022c.289.193.444.206.466.392.052.316-.521.596-.521.596l-.006-.01s-.401-.146-.451-.618c-.048-.471-.082-1.109-.082-1.109s.001.186.043.242c.125.161.202.274.551.507",
    style: {
      fill: "#616161"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.443 100.726.421.159c1.028-.574 1.394-.751 1.638-.896 1.102-.656 2.414-1.457 2.76-1.729 0 0 .709-.483.108.182a16 16 0 0 1-.901.938s-.583.583-.438.729c0 0 .155.229 1.112-.638.954-.866 2.003-2.104 2.12-2.275.119-.174.138-.274.138-.274s.101-.2.255-.364c.134-.141 1.283-1.393 1.857-1.976l.007.003q.382-.508.749-1.027c-.333.354-1.605 1.705-2.313 2.5 0 0-.664.709-.874.983s-.209.438-.209.438-.109.183-.363.482c-.256.301-1.157 1.103-1.157 1.103s-.537.437-.701.445c-.165.009.4-.501.4-.501s.547-.583.901-1.048c.356-.464.127-.437.127-.437s-.172-.045-.919.428c-.746.473-1.274.802-1.274.802s-1.604.919-2.623 1.511-3.352 1.777-4.68 2.322c-1.33.547-2.013.665-1.895.491.118-.173.428-.427.428-.427s.374-.373.374-.747c0 0 .118-.546-1.494-.208-1.611.337-3.068 1.129-3.068 1.129s-2.396 1.102-1.83 1.758c0 0 .109.173.591.327.483.155-.856.565-.856.565-1.273.418-2.25.608-3.486.863a258 258 0 0 0-4.116.885s-1.129.272-3.006 1.001-5.563 1.33-5.563 1.33-2.368.273-2.587.584c-.218.309.165.464.165.464s.337.208 1.557.265c0 0 .42 0 .438.035.016.036.044.063-.219.146-.266.082-.795.293-2.588.518-1.803.229-1.766-.063-1.766-.063s-.009-.073.073-.201c.081-.125.008-.344-.273-.499 0 0-.391-.255-1.704-.244-1.312.009-3.924.016-6.365-.128-2.211-.133-5.208-.513-5.681-.62 0 0-.109-.028-.192-.109-.082-.083-.602-.393-1.084-.684s-1.931-.847-1.931-.847-1.873-.729-1.812-.482c.014.056.121.143.249.228q.49.265.987.521l.002-.002s-.692-.374-.501-.374.408.102.408.102 1.13.31 1.832.637c.701.328 1.311.774 1.311.774s.865.51 2.16.683c1.254.168 2.957.36 3.518.418l.554-.255.403.329c1.031.066 2.399.137 2.399.137s2.772.104 4.29-.017c.683-.057.473.298.473.298s-.2.329.191.493c0 0 .718.411 3.115.146 2.396-.266 2.923-.803 2.923-.803s.278-.257-.327-.372c-.475-.092-.475-.046-1.094-.11-.619-.063-.93-.191-.519-.301.411-.108 1.093-.163 1.093-.163s2.096-.292 3.788-.73c0 0 1.805-.426 3.598-1.056a30 30 0 0 1 1.758-.556l.41-.599.597.347.095-.02s2.148-.502 3.051-.655c.9-.156 2.939-.593 3.807-1.012.865-.418 1.301-.748 1.402-1.002.1-.255-.364-.4-.364-.4s-.548-.128-.475-.318c.072-.191.273-.355 1.13-.738.856-.382 1.931-.801 3.006-1.065s.683.183.683.183-.646.656-.729.91c-.081.256.027.265.11.31.082.046.601.028.955-.063.356-.091 3.226-1.184 4.974-2.186q.066-.037.128-.074z",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.561 90.203.166.123-.155-.146-.023.001z",
    style: {
      opacity: 0.68000034,
      fill: "url(#ah)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.864 82.698-.346-.019c-1.684 1.364-2.182 1.805-3.524 2.754 0 0-1.53 1.143-3.206 2.047-1.678.902-3.649.793-3.649.793s-.535-.056-.276-.443c.258-.387.59-1.327.718-1.806.13-.48.387-1.696-.59-2.083-.976-.386-2.809.183-2.809.183s-4.217 1.123-5.936 3.011c-1.669 1.834-.268 2.649-.268 2.649s.657.457 1.291.683c.6.212.479.404.33.515 0 0-1.882 1.2-4.106 1.839 0 0-3.043.932-6.001 1.123-2.94.19-4.188.265-4.188.265l-.373.351-.706-.234c-1.195.145-3.217.432-5.212.914-2.442.594-4.772 1.07-6.431 2.139 0 0-1.241.824-.527 1.627.712.803 1.458 1.146 1.458 1.146s.44.194.433.313c-.009.154-.014.287-.342.476 0 0-1.299.761-3.827.803-2.528.041-3.643.017-4.385-.649-.613-.551.154-1.717.154-1.717s.307-.572 0-1.355c-.307-.781-2.066-.795-2.066-.795l-2.436-.123c-2.883-.075-6.69-.397-8.385-.609l-.031-.005-.006.153-.672-.281c-1.061-.205-3.021-.622-3.796-1.009-.707-.354-1.087-.292-.993-1.026.094-.715-.702-1.71-.702-1.71s-1.106-1.199-2.102-1.944c-.996-.746-1.419-.526-1.419-.526s-.451.24-.046 1.207c.406.969.801 1.309.801 1.309s.194.203.083.259c-.11.056-.451-.202-.735-.443-.236-.196-1.756-1.622-2.288-2.122l.098.334.049.08c.171.271.797 1.179 2.007 2.125 1.443 1.128 1.452.678 1.452.678s.057-.373-.277-.782c-.335-.411-.87-1.28-.737-1.597.134-.315.288-.287.288-.287s.124-.047.555.278c.43.325 1.395 1.003 1.873 1.586.478.581.448 1.099.448 1.099s-.095.525.421 1.09c.516.563 1.615 1.596 5.458 2.189l.055.008.18-.513.534.619c3.352.483 5.175.525 5.175.525s4.387.153 5.573.153c1.185 0 .964.62.964.62s-.067.335-.21.603c-.144.267-.488 1.271-.134 1.807 0 0 .545 1.329 4.081 1.424 0 0 3.097.248 5.257-.642 2.16-.889.21-2.121.21-2.121s-.74-.449-1.053-.688c-.286-.22-.171-.45-.113-.603.056-.152.277-.335.525-.459.248-.125 1.155-.61 4.998-1.604 3.842-.996 6.136-1.101 6.136-1.101l.05-.004.316-.611.796.517c.682-.056 1.564-.12 2.354-.159 1.577-.076 4.044-.438 5.477-.752 1.434-.318 3.604-.986 5.209-1.817 1.605-.832 1.683-1.413 1.683-1.413s.306-.442-.363-.928c-.67-.488-.966-.355-1.558-.957-.593-.603.516-1.51.516-1.51s.572-.803 3.747-2.026c3.173-1.222 3.708-.813 3.87-.678.163.134.182.573.115.869s-.46 1.357-.67 1.912c-.211.553-.296 1.309.564 1.491.859.181 2.063-.008 3.192-.413 2.694-.963 3.499-2.138 7.951-5.368l.028-.022zl.642.103c1.841-1.467 3.603-3.328 3.603-3.328s1.172-1.174 1.76-2.195c.554-.958.026.828.026.828s-.299 1.412.178 1.935c.38.415 1.457-.739 1.457-.739s.641-.736.898-1.92c.38-1.746.172-2.094.172-2.094s-.229-.362-.086-.793c.144-.429 1.08-2.839 1.845-3.736l.467-.525.002-.025-.207-.519.281-.477s-.26.299-1.307 2.027c-1.18 1.945-1.367 3.515-1.367 3.515s-.111.609-.049.964c.059.331.174.482.181.579s-.069.893-.474 1.652c-.405.76-.76.961-.76.961s-.704.509-.802.147a2.1 2.1 0 0 1-.034-.899c.034-.231.271-1.471.236-1.931-.034-.46-.447-.09-.447-.09s-.097.111-.277.341c-.182.231-1.201 1.525-1.589 1.979-.921 1.079-1.756 1.855-3.998 3.661q-.01.006-.017.013z",
    style: {
      opacity: 0.43000004,
      fill: "url(#ai)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.749 72.069.097.908c.219.265.538.629.998 1.104 1.01 1.044 1.33.388 1.33.388s.236-.657-.05-1.851c-.286-1.197-.236-1.905.303-1.886.538.017 2.104.336 2.591 1.632 0 0 .202.605.017 1.379-.186.776-.151 1.464-.017 2.138.135.674.707 1.312 1.364 1.835s2.558 1.431 4.41 1.548c1.851.117 2.423.018 2.423.018l.695-.712.125.622a784 784 0 0 1 3.372-.365c2.355-.252 3.938-.506 5.402-.287 1.465.22 1.936 1.363 1.936 1.363s.101.292-.235.506c-.325.208-.698.509-.883.828-.185.321-.383.996.149 1.897.533.896 1.995 1.482 3.24 1.333 1.244-.147 3.107-.625 4.21-.913 1.199-.313 2.259-.903 2.396-1.844s-1.429-2.138-1.429-2.138-.756-.57-.848-.699c-.093-.129.092-.186.092-.186s.884-.212 1.264-.385c.376-.178 1.418-.601 3.123-1.134 1.706-.535 5.225-1.162 5.225-1.162s1.941-.31 4.364-.506l.579-.656.452.583q.572-.034 1.158-.057c3.327-.12 4.976-.516 6.745-.913 1.769-.396 4.257-1.842 4.626-2.12.368-.275 1.143-.616 1.299-1.823s-1.271-2.009-1.271-2.009-1.135-.6-1.374-.867-.018-.524-.018-.524.644-1.383 2.699-2.193c2.055-.812 3.438-1.032 4.303-1.125.867-.092 1.161.221 1.28.369.119.146.119.452.02.765-.094.287-.414.967-.6 1.299-.184.332-.488 1.133-.295 1.511.194.377.784.553 1.548.415.765-.139 2.783-.709 4.552-1.447 1.77-.738 4.728-2.184 4.728-2.184l.021-.011.081-.679.677.275c.949-.523 2.574-1.472 3.735-2.451 1.743-1.465 3.447-3.004 3.88-3.39.434-.388.83-.701 1.217-.682s.683.295.921 1.336c.24 1.041.286 1.898.397 2.405.11.506.266 1.095.866 1.215.599.12 1.408-.404 1.713-.664.306-.257.856-1.096.82-2.219 0 0 .065-1.494-.708-2.913 0 0-.325-.572-.445-.728-.081-.11-.146-.222-.009-.489.139-.267.435-.765.987-1.077.419-.238.82-.295 1.051-.369 0 0 .258-.063.583-.243l-.118-.384.27.295c.378-.223.61.042.61.042l-.365-.467.111-.451s-.283-.152-.638-.082c-.356.072-.392.337-.943.427-.552.089-1.19.285-1.813 1.228-.624.942 0 2.116 0 2.116s.336.551.497.836.995 2.063.036 3.361c0 0-.515.599-1.423.801-.802.177-.596-.76-.678-1.263 0 0-.121-2.125-1.154-3.343-.908-1.067-2.559.827-3.38 1.459-.766.586-3.006 2.899-6.226 4.588l-.474.831-.303-.44c-1.544.77-5.046 2.474-7.332 3.273 0 0-1.745.71-2.456.729 0 0-.158.006-.034-.167.124-.172.258-.3.472-.687.216-.389.604-1.264.604-2.168 0-.903-1.043-1.785-2.495-1.628-1.453.156-2.845.559-4.518 1.204s-3.113 2.012-3.307 3.145 1.032 1.789 1.032 1.789 1.382.7 1.558 1.078c.175.378.046.729.046.729s-.121.378-.729.727c-.607.351-2.257 1.199-2.257 1.199s-2.054 1.133-5.178 1.408c0 0-2.849.242-4.488.324q-.032.002-.064.003l-.504.494-.546-.418c-1.528.126-3.298.335-3.298.335s-3.996.568-7.657 1.697c-3.108.958-3.699 1.485-3.699 1.485s-.662.554-.11 1.353c0 0 .318.502.959 1.006.638.504 1.153.984 1.08 1.229-.074.246-.27.356-.27.356s-.896.799-4.559 1.413c0 0-2.358.455-3.083-.258s-.405-1.192-.405-1.192.048-.16.577-.491c0 0 .886-.554.603-1.608-.282-1.057-1.984-2.371-3.821-2.36 0 0-2.145.006-7.635.708l-.025.004-.19.467-.564-.365c-.301.036-.664.073-1.038.101-.943.067-2.307-.052-4.006-.555-1.699-.505-2.76-1.43-2.912-1.986-.106-.384.033-.928.033-.928s.318-1.227.118-2.238c-.205-1.009-.542-1.801-1.519-2.391-.976-.589-1.531-.487-1.531-.487s-.875-.134-.842 1.347c.034 1.482.219 2.103.219 2.103s.169.522-.101.59c-.268.067-.689-.336-.689-.336s-.951-.861-1.508-1.573l.044.063-.199.49s.063.109.248.349z",
    style: {
      opacity: 0.23999999,
      fill: "url(#aj)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.481 37.786.17.788s-.525.292-1.563.571c-1.037.28-2.038.746-2.038.746s-.827.269-.513.944c.314.676.781 1.002.781 1.002s.663.643.687 1.13c.023.49-.187.712-.711 1.002a3 3 0 0 1-1.002.35s-1.246.223-1.864-.361c-.617-.583-.733-1.549-.733-1.549s-.047-.816-1.072-1.166c-1.026-.349-2.284.396-2.284.396s-.99.525-2.051 1.211c-1.061.688-3.065 1.528-4.323 1.97l-.143.651-.705-.356c-1.325.456-3.046 1.033-3.046 1.033s-2.341.863-3.879 1.073-1.877-.013-2.087-.222c-.21-.208.036-.943.036-.943s.628-1.282.325-1.947-2.285-.839-2.318-.839c-.036 0-2.159-.247-4.146.868-1.764.99-1.996 1.53-1.996 1.53s-.56.873.105 1.739c.752.98 1.753 1.067 1.753 1.067s.949.074 1.171.354.07.583.07.583-.313.862-2.074 1.223c0 0-2.962.869-8.489 1.655l-.542.539c-3.487.438-7.586 1.27-9.833 1.853-2.247.584-2.378 1.227-2.378 1.227-.483.758.131 1.152.131 1.152s.772.263.947 1.109c.177.847-.729 1.518-.729 1.518s-1.08.905-2.7 1.182-2.232.326-3.195-.438c-.847-.671-.277-1.735.291-2.144.57-.408.847-.847.92-1.036s.03-.351.03-.351l-.54-.497c-1.868-1.239-9.207.059-9.207.059q0 .002 0 0l-1.249.269-.627-.405s-2.134.563-4.542.549c-2.527-.013-1.183-1.983-1.183-1.983s.594-1.041.699-1.643c0 0 .209-1.625-1.323-1.519-1.532.104-1.833 1.44-1.833 1.44s-.104.746-.083 1.297c.02.553-.002 1.72-.691 2.384-.687.664-1.425.461-1.425.461s-1.24-.542-1.486-.669c-.255-.132-.482-.141-.7-.062a.3.3 0 0 0-.053.027l-.163.699.024-.58a2 2 0 0 0-.252.391l.082.305-.231.526-.005.033.007.003s.081-.183.207-.333l.169-.344-.048.225a.3.3 0 0 1 .16-.069c.261-.016.586.147.586.147s1.057.569 1.529.667c.473.098.815-.061 1.122-.272.492-.34 1.065-1.044 1.305-1.713.214-.602.26-2.23.26-2.23l.004.013s0-.392-.01-.482c-.011-.091-.07-.515.19-.73.259-.218.428-.323 1.065-.339.634-.016.826.354.826.354s.217.302.217.499c0 .195-.063.317-.063.317s-.345.583-.466.87c-.121.286-.593 1.233-.456 2.028.138.794 1.378 1.166 1.378 1.166s.989.232 2.399.025l2.907-.469.506-.581.203.441c.75-.137 1.993-.344 3.338-.476 2.167-.212 4.459-.244 5.423-.123 0 0 .451.057.377.218-.058.127-.392.386-.392.386s-.126.075-.609.621-.625 1.076-.646 1.547.481 1.859 2.25 2.23c1.771.37 3.798-.317 3.798-.317s1.329-.293 2.595-1.56c1.313-1.314.011-2.895.011-2.895s-.205-.283-.603-.412c0 0-.174-.047-.074-.158.101-.112.345-.603 1.276-.843.931-.239 3.705-1.116 10.308-1.989l.255-.575.814.428c2.522-.348 4.239-.647 7.291-1.354 0 0 2.833-.502 3.423-1.539.343-.605.962-1.433-.042-2.267 0 0-.118-.15-.738-.29s-1.095-.235-1.619-.609c-.523-.375-.513-.809-.513-.809s-.044-.415.805-.892c0 0 .791-.58 2.366-1.078 1.576-.497 3.4-.276 3.4-.276s.765.083.636.599c-.129.517-.561 1.381-.579 1.825-.02.442.009.957.874 1.317.866.359 2.111.248 2.111.248s1.289-.064 3.4-.746c2.108-.681 4.277-1.465 4.277-1.465l-.085-.451.901.162a34 34 0 0 0 2.13-.872c1.677-.754 2.476-1.386 3.244-1.824 0 0 1.691-1.042 2.688-1.014 0 0 .233-.009.255.298.021.306.098.758.202 1.021a3.01 3.01 0 0 0 2.542 1.908c1.857.212 2.651-1.042 2.651-1.042s.635-.977-.462-2.139c0 0-.893-.958-.921-1.032 0 0-.097-.144.155-.217.251-.073 2.938-.824 3.976-1.303l.034-.014-.253-.452.499.342c.188-.094.419-.229.507-.368.159-.252-.05-.743-.05-.743l.006-.006q-.185-.257-.373-.509l-.568-.238-.055.031z",
    style: {
      opacity: 0.2,
      fill: "url(#ak)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.202 42.054-.271.406c.125-.022.227-.052.227-.052s.376-.062 1.036.112c.854.227 1.925-.462 1.925-.462s.812-.487 1.187-1.287l.336-.936s.271-.906 1.03-1.193c0 0 .296-.159.774-.165.478-.005.365.33.365.33s-.052.217-.546.849c-.493.631-.625 1.114-.625 1.114s-.296.673.18.891c0 0 .223.132.875-.085s2.813-.785 4.133-.987l.925-.472-.56-.414c-2.225.412-3.883.927-4.449 1.142-.567.214-.577.076-.577.076-.197-.231.405-.952.405-.952s.61-.833.85-1.598c.241-.764-.831-.658-.831-.658-.706.112-1.214.447-1.798 1.151-.453.546-.729 1.294-.832 1.69-.066.249-.18.48-.18.48s-.085.154-.419.3c-.388.169-1.144.369-1.144.369s-.503.042-.868-.14c-.223-.11-.839.047-.839.047l.084-.47-.076-.03-.636.357q-.16.264-.318.53c-.059.136-.167.442.041.475a1 1 0 0 0 .153.008zM32.023 35.408s.319-.253.319-.024c0 .23-.31.643-.31.643s-.1.125-.16.125c-.06-.001.016-.44.151-.744M29.508 38.493s-.361.429 0 .484l.781-.771c-.034-.034-.05-.051-.146-.104 0 0-.489.244-.635.391M92.119 106.725s-1.63.75-3.162 1.493c-1.536.746-2.095 1.06-2.095 1.06s-.083.045-.03.075c.052.029-.008.061-.008.061-.788.382-2.517.998-2.517.998s-.156.053-.148.017c.006-.039.187-.099.187-.099s.354-.135.264-.202c-.091-.067-1.127.284-1.127.284s-1.817.578-2.696.825c-.878.249-2.562.686-2.562.686-1.119.277-3.493.743-4.02.841-.524.097-.389.06-.389.06s.459-.175-.383-.21c-1.067-.045-2.201.105-3.364.27-1.166.166-1.098.302-1.098.302s-.037.144.66.128c.7-.016.497.044.497.044-1.3.188-3.912.221-3.912.221l.004.01q.638.018 1.282.017.851 0 1.697-.03c.225-.022 1.383-.142 1.793-.229.454-.099-.086-.099-.086-.099l-.689-.024s-.725-.024-.049-.147c.677-.123 1.709-.178 2.225-.233.773-.088.503.098.503.098l-.037.023s.013.087.493.063c.479-.024 4.397-.749 6.586-1.388 2.185-.639 3.82-1.168 3.82-1.168s.147-.049.062.025c-.087.074-.431.186-.431.186s-.553.28.786-.1l.185-.055a48 48 0 0 0 3.385-1.438c.027-.028.121-.135-.018-.093-.161.051 0-.062.172-.123s2.112-1.081 3.133-1.498l.002.003q.55-.314 1.091-.644z",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.749 72.069.1.913c.22.266.539.629.994 1.1 1.01 1.044 1.33.388 1.33.388s.067-.188.086-.546c-.04.201-.195.375-.734-.052-.278-.221-.641-.584-1.002-.977a13 13 0 0 1-.951-1.041l.044.063-.198.49s.064.108.249.351z",
    style: {
      fill: "url(#am)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.123 72.617-.018-.072q.018.122.04.255s.087.366.112.701a5 5 0 0 0-.134-.884",
    style: {
      fill: "url(#an)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.512 53.459.27.294c.378-.222.611.042.611.042l-.359-.46c-.356.076-1.019.238-2.082.569 0 0-1.259.553-1.481 1.427-.013.309.044.597.11.816.7 1.331.851 1.552.851 1.552.464 1.017.39 1.856.232 2.631-.174.858-1.105 1.554-1.671 1.716-.568.159-.888 0-1.062-.451-.175-.452-.146-.787-.407-2.18-.262-1.396-.611-2.049-1.134-2.209s-1.221.436-1.629.755c-.406.32-2.251 2.005-2.251 2.005s-2.166 1.948-5.35 3.75-7.166 3.184-7.166 3.184-2.646 1.017-3.284.93c-.639-.087-.479-.669-.276-1.003a11 11 0 0 0 .712-1.439c.289-.704.188-1.541-.335-1.832-.522-.29-1.162-.436-3.284.087-2.121.524-2.979 1.003-3.575 1.352s-1.467 1.149-1.715 1.599c-.246.451-.523.916.117 1.468.639.553.711.452 1.452.974.741.523.858.596.901 1.366s-.711 1.249-.711 1.249-2.909 1.94-6.148 2.587c-2.181.437-6.366.596-6.366.596s-1.236-.043-5.015.509-6.323 1.409-7.209 1.73c-.887.319-2.18.754-2.921 1.09-.741.334-.35.828-.189.944s1.104 1.003 1.395 1.263c.291.264 1.366 1.192.101 1.965-1.263.771-3.356 1.177-3.356 1.177s-2.907.61-3.837.218c-.932-.393-1.118-.725-1.352-1.265-.292-.669-.015-1.177.74-1.658.717-.454.437-1.118.437-1.118-.916-1.772-2.849-1.917-4.448-1.803a133 133 0 0 0-6.917.684c-2.849.363-4.23-.057-5.582-.479-1.352-.423-2.792-1.426-2.938-2.328a1.2 1.2 0 0 1-.039-.284c-.072-.706.069-1.068.171-1.662.101-.582-.04-1.428-.078-1.638l-.022-.079c-.473-1.214-1.607-1.773-2.486-1.917-.887-.146-.916.799-.916.799l-.006.037c.073-.194.207-.294.414-.289.538.018 2.104.337 2.591 1.634 0 0 .203.605.017 1.379-.185.775-.151 1.464-.017 2.137.135.675.707 1.313 1.365 1.835.656.521 2.557 1.43 4.41 1.547 1.69.109 2.313.033 2.41.021l.707-.715.126.621c.755-.082 1.971-.215 3.371-.365 2.356-.251 3.938-.504 5.403-.285s1.936 1.363 1.936 1.363.1.29-.236.505c-.325.208-.698.51-.882.829-.186.32-.383.995.148 1.895.533.898 1.995 1.483 3.24 1.335 1.244-.148 3.108-.626 4.211-.914 1.198-.313 2.258-.902 2.396-1.842s-1.429-2.14-1.429-2.14-.755-.57-.847-.699c-.093-.129.092-.184.092-.184s.885-.213 1.263-.387c.376-.178 1.419-.599 3.123-1.134 1.706-.534 5.225-1.162 5.225-1.162s1.947-.31 4.373-.506l.57-.656.459.584q.568-.035 1.151-.056c3.326-.12 4.976-.517 6.745-.912 1.768-.397 4.257-1.844 4.625-2.121s1.143-.617 1.299-1.824c.157-1.206-1.271-2.009-1.271-2.009s-1.134-.599-1.374-.866c-.239-.268-.018-.524-.018-.524s.645-1.383 2.7-2.194c2.055-.812 3.438-1.031 4.302-1.124.867-.092 1.162.221 1.281.368.12.147.12.452.019.765-.093.287-.414.968-.599 1.3s-.489 1.133-.296 1.511c.195.377.784.552 1.548.414.767-.138 2.783-.709 4.553-1.447s4.727-2.183 4.727-2.183l.021-.012.08-.679.678.276c.95-.524 2.574-1.473 3.736-2.45 1.742-1.466 3.446-3.004 3.88-3.392.434-.386.829-.7 1.216-.682.387.02.683.296.922 1.336.24 1.042.285 1.898.396 2.406.11.505.267 1.096.866 1.216s1.409-.406 1.714-.664.856-1.096.82-2.22c0 0 .063-1.495-.71-2.913 0 0-.325-.572-.443-.728-.082-.111-.146-.222-.009-.488.138-.268.434-.765.987-1.078.419-.238.82-.295 1.051-.369 0 0 .261-.065.591-.248z",
    style: {
      opacity: 0.77999998,
      fill: "url(#ao)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.079 57.306-.047.223a.3.3 0 0 1 .159-.067c.261-.016.586.147.586.147s1.057.569 1.529.667c.473.098.815-.061 1.122-.272a3.6 3.6 0 0 0 .711-.687c-.27.27-.675.51-1.272.554 0 0-.532-.046-1.322-.547-.788-.5-1.236-.215-1.611.098l-.232.525-.005.034.008.001s.081-.179.202-.328zM25.588 56.621q.083-.167.144-.33c.047-.13.084-.311.117-.512-.089.41-.208.68-.208.68s-.015.062-.053.162M25.979 53.541c-.035.409-.035.92-.035 1.391.037-.474.048-.871.048-.871l.004.013s0-.392-.01-.482zM27.202 42.054l-.271.406c.081-.013.083-.007.227-.052 0 0 .376-.062 1.036.112.854.227 1.925-.462 1.925-.462s.254-.153.543-.426c-.373.223-1.29.71-1.986.545-.895-.213-.926-.016-1.245-.046-.272-.026-.272-.103-.256-.293.002-.03.022-.051.028-.086.047-.243.316-.642.316-.642l-.637.357q-.16.264-.317.53c-.059.136-.167.442.041.474a1 1 0 0 0 .152.008zM35.492 40.855c-.957.259-1.837.684-2.323.563-.408-.102-.078-.708.039-.899.064-.135.156-.272.232-.378.288-.471.776-1.258.776-1.258v-.002q.023-.046.045-.095c.063-.168.112-.5-.439-.556-.745-.076-1.503.576-1.503.576s-.51.281-.781 1.32l.104-.292s.271-.906 1.03-1.193c0 0 .296-.159.774-.165.478-.005.365.33.365.33s-.052.217-.546.849c-.493.631-.625 1.114-.625 1.114s-.297.673.18.891c0 0 .222.132.875-.085.652-.217 2.813-.785 4.133-.987l.925-.472c-.625.052-2.336.49-3.261.739M104.018 95.987l.012-.012zM104.244 95.738l.003-.004zM104.167 95.822l.01-.011zM101.524 98.279l-.154.162c-.602.666-.901.938-.901.938l-.226.25q-.004.007-.01.011.006.004.037.004s.214-.001.549-.204a.5.5 0 0 1-.169.067c-.164.009.4-.501.4-.501s.547-.583.901-1.048c.356-.464.128-.437.128-.437s-.081-.02-.37.117c.023.026.156.216-.185.641M104.091 95.907a.04.04 0 0 1 .012-.014q-.007.006-.012.014M87.592 102.5s2.063-.867 3.169-.736c0 0 .571.055-.056.662-.626.608-.828 1.087.369.701l.228-.081c-.469.134-.685.134-.613.031.118-.175.429-.428.429-.428s.372-.374.372-.746c0 0 .119-.548-1.493-.21-.943.196-1.834.55-2.411.81zM86.929 102.822l-.003.001zM101.669 97.659l-.041.02zM92.583 102.584c1.351-.487 3.661-1.729 4.68-2.322-1.019.592-3.351 1.778-4.68 2.322M101.161 97.949c.024-.016.051-.03.073-.045q-.034.023-.073.045M104.986 94.929c.008-.009.018-.021.025-.026-.008.005-.017.017-.025.026M104.814 95.113q.013-.013.023-.025-.01.013-.023.025M86.009 103.319q-.017.011-.034.021zM104.733 95.201l.019-.02zM104.483 95.475l.011-.014zM104.645 95.299l.019-.021zM104.398 95.566l.015-.016a.1.1 0 0 1-.015.016M104.56 95.39l.016-.018zM86.541 103.016l-.025.014zM86.752 102.906l-.018.009zM86.063 103.287l-.03.018zM86.682 102.942l-.021.012q.01-.007.021-.012M86.813 102.876l-.015.009zM86.718 102.924l-.02.01zM86.903 102.832l-.006.004zM86.85 102.858l-.024.012zM86.643 102.963l-.025.013q.012-.007.025-.013M86.89 102.84l-.011.004q.005-.003.011-.004M86.871 102.849l-.013.006q.007-.003.013-.006M86.784 102.892l-.017.007zM86.586 102.993q-.013.004-.026.012.013-.008.026-.012M86.296 103.148l-.048.028q.025-.013.048-.028M86.914 102.827l-.002.003zM86.171 103.222q-.015.008-.029.019.014-.012.029-.019M86.228 103.188l-.032.02zM86.494 103.04q-.013.006-.024.014.012-.008.024-.014M105.07 94.837l.037-.039zM86.447 103.066l-.026.014zM86.398 103.093l-.026.015q.012-.008.026-.015M86.348 103.119l-.029.018q.014-.007.029-.018M105.808 94.047l-.027.03zM105.143 94.758q.03-.03.057-.059zM105.882 93.97l-.029.03zM106.051 93.788l-.002.001zM105.997 93.845l-.012.014zM101.557 97.716l-.04.022zM105.945 93.902l-.027.027zM101.305 97.86l-.047.028q.024-.012.047-.028M64.543 111.645l-.003.002zM64.421 111.649h-.019zM64.48 111.647l-.018.001zM64.358 111.651h-.011zM64.297 111.652h-.014zM101.494 97.75q-.016.01-.036.02.02-.01.036-.02M101.435 97.784q-.018.011-.038.021.02-.01.038-.021M101.57 97.709q.027-.015.05-.026-.023.01-.05.026M101.353 99.062s-.075.062-.18.139c.061-.045.13-.096.18-.139M105.533 94.342l-.06.063zM45.768 107.898l-.052-.019q.027.011.052.019M85.826 103.437l-.034.022zM62.354 110.569q-.034-.003-.069-.004.036.001.069.004M45.422 107.784l.054.017zM45.307 107.748l.111.035q-.057-.019-.111-.035M45.593 107.839l-.114-.037q.056.017.114.037M105.23 94.665l.038-.041zM45.776 107.901l.108.037zM105.32 94.568l.038-.04zM105.395 94.49l.054-.057zM85.903 103.387l.051-.033zM62.826 110.619l-.049-.006zM85.892 103.394l-.045.03zM62.899 110.632l-.046-.007zM62.968 110.645l-.044-.01zM62.579 110.587l-.093-.009q.05.007.093.009M62.749 110.608l-.056-.007zM62.463 110.577q-.035-.004-.074-.006.038.001.074.006M63.789 111.597q.002.002.004.002-.002 0-.004-.002M63.771 111.591l.003.001zM63.855 111.616l.006.001zM63.833 111.609l.002.002zM63.039 110.658l-.05-.011zM63.201 110.699l-.03-.009zM65.33 111.576l-.029.004zM64.136 111.647h.006zM64.186 111.649h.012zM61.758 110.555h.129zM64.089 111.645q.007 0 .012.002-.005-.002-.012-.002M63.209 110.701s.147.019.055.314c-.093.294.056.422.442.553l.022.005h.002c-.074-.037-.069-.074-.069-.074s-.009-.073.073-.201c.081-.125.008-.344-.273-.499.001 0-.07-.045-.252-.098M64.231 111.651h.017zM63.883 111.622h.003zM64.052 111.642l.009.001zM63.914 111.625l.002.001zM63.942 111.63l.007.001zM63.975 111.635l.008.001zM63.153 110.686l-.04-.01zM46.418 108.133l-.023-.009zM46.445 108.144l-.022-.009zM46.356 108.11q-.013-.005-.028-.011.015.006.028.011M62.173 110.561q.037.001.069.003zM46.464 108.15l-.02-.007zM45.144 107.702q.052.015.104.028-.053-.013-.104-.028M45.248 107.73l.054.017zM46.48 108.158q-.004-.003-.011-.005zM46.318 108.097l-.028-.011zM45.43 108.116a.2.2 0 0 1-.028-.029.96.96 0 0 1-.32-.39l.009-.01q.023.009.048.013c-.271-.071-.466-.099-.446-.016.014.056.122.143.25.229q.241.13.486.259zM46.389 108.122l-.025-.009zM46.282 108.082l-.039-.014zM46.505 108.167q0 0-.021-.009zM45.938 107.957l-.044-.016zM62.056 110.556l.075.003zM61.928 110.555h.083zM46.193 108.05l-.035-.014zM46.24 108.066l-.037-.013q.02.008.037.013M84.866 105.462l.005-.001zM85.583 105.18l-.004.003zM85.557 105.193l-.005.004zM85.529 105.207l-.006.004zM85.497 105.223l-.002.001zM85.237 105.331l.008-.002zM85.209 105.344l.003-.001zM85.142 105.368l.008-.003q-.004 0-.008.003M85.113 105.378l.008-.003zM85.176 105.355l.002-.001zM65.235 111.588q-.016.001-.031.003.015-.002.031-.003M85.086 105.389l.006-.002zM85.574 103.618q.018-.015.039-.03zM85.738 103.496l.032-.021zM85.686 103.535l.031-.022q-.016.01-.031.022M85.689 104.907c.188.06.099.159-.08.259l.083-.03s.738-.405.425-.59c-.314-.185-1.051-.258-.571-.902l.019-.017c-.414.318-.705.675-.466.951-.001.002.108.175.59.329M85.374 105.277l-.007.003zM85.436 105.251l-.007.003zM85.307 105.306l-.006.002zM85.276 105.316l-.008.004zM85.631 103.574l.033-.023zM64.626 111.642l-.022.001zM64.767 111.633h-.016zM64.697 111.638h-.025zM66.238 110.6s.337.208 1.558.265c0 0 .419 0 .437.034.014.027.032.05-.065.093.055-.02.738-.236.442-.363l-.069-.027-.016-.002-.02-.004-.012-.001-.018-.004-.014-.003-.015-.001-.014-.003-.014-.001q-.01 0-.016-.003l-.013-.002-.016-.001q-.005-.002-.01-.002l-.019-.002-.007-.001-.026-.002-.004-.001-.02-.001q-.004-.002-.009-.002h-.025l-.017-.002h-.007l-.017-.002-.009-.001h-.02l-.003-.001-.122-.007h-.004l-.02-.001h-.01l-.019-.001-.013-.001-.018-.002-.015-.001-.018-.001q-.014 0-.026-.003h-.017l-.026-.002-.015-.002-.023-.001-.019-.001q-.011-.002-.024-.003l-.018-.001-.025-.003-.021-.002-.026-.003-.02-.001-.032-.004-.018-.001-.053-.006a4 4 0 0 1-.352-.05l-.174-.023s-.438-.012-.608-.295c-.11-.185.425-.297.425-.297s.891-.182 1.785-.301c0 0-2.368.273-2.587.583-.211.314.171.47.171.47M84.838 105.471h.003zM65.135 111.599l-.02.002zM65.03 111.609l-.024.002zM84.977 105.426l.009-.004zM84.956 105.433l.006-.002zM85.027 105.408l.004-.002zM84.911 105.447q.004 0 .007-.002-.004.002-.007.002M85 105.417q.005 0 .01-.003zM84.844 105.468h.004zM84.851 105.467l.006-.001zM86.925 102.824l-.004.001zM84.896 105.452h.004zM84.881 105.458l.004-.002z",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.727 90.326-.13-.123-.019.011z",
    style: {
      fill: "url(#ap)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.864 82.698.641.103c1.841-1.467 3.604-3.328 3.604-3.328s1.172-1.174 1.76-2.196c.204-.354.262-.333.252-.164.021-.084.096-.425-.035-.666-.088-.164-.356.269-.773.803 0 0-1.875 2.724-5.402 5.419-3.528 2.692-4.45 3.511-7.53 5.268 0 0-2.151.95-3.646.624-1.161-.253-.001-1.441.253-2.515.252-1.07.059-1.473-.208-1.683-.268-.207-.849-.357-1.995-.103 0 0-4.387 1.178-6.354 3.08-1.787 1.728.445 2.44.952 2.68 0 0 .729.313.669.625s-.462.579-.685.729-3.109 1.841-7.754 2.574c-3.764.596-3.037.238-6.653.61-3.615.373-4.613.671-7.515 1.354-2.903.686-4.607 1.432-4.986 2.188-.313.625.446 1.027.923 1.31.476.283 1.326.729 1.042 1.205s-1.519 1.19-4.54 1.295-4.256-.313-4.807-.968c-.51-.606-.074-1.234.09-1.814 0 0 .356-.76.149-1.131-.208-.372-.686-.462-1.19-.521-.507-.06-3.023-.147-4.972-.253-2.209-.118-4.852-.195-8.022-.864 0 0-2.084-.412-3.438-1.175a3 3 0 0 1-.233-.146.6.6 0 0 1-.233-.194c-.382-.402-.044-.698-.173-1.088-.112-.336-.328-.818-.835-1.399a23 23 0 0 0-.67-.664q-.112-.097-.237-.199c-1.189-.966-1.325-1.071-1.83-1.086s-.219.833-.12 1.161c.038.126.129.305.225.473-.186-.34-.313-.678-.24-.852.134-.315.288-.287.288-.287s.124-.047.554.277c.431.325 1.396 1.004 1.874 1.587.477.583.448 1.099.448 1.099s-.095.525.42 1.09c.517.563 1.615 1.597 5.458 2.189q.029.004.056.008l.18-.513.529.619.015.002c3.346.482 5.165.523 5.165.523s4.387.154 5.572.154.964.619.964.619-.067.335-.209.603c-.143.269-.488 1.272-.134 1.808 0 0 .545 1.328 4.082 1.423 0 0 3.096.248 5.256-.641 2.159-.889.209-2.121.209-2.121s-.74-.45-1.052-.688c-.287-.219-.171-.449-.114-.603.057-.152.277-.333.526-.459.247-.124 1.156-.609 4.998-1.604 3.842-.994 6.136-1.1 6.136-1.1q0-.001.056-.005l.31-.611.787.518c.684-.055 1.571-.12 2.364-.158 1.577-.077 4.044-.44 5.477-.754 1.434-.317 3.604-.985 5.209-1.817 1.605-.831 1.683-1.414 1.683-1.414s.306-.44-.364-.928c-.669-.487-.966-.354-1.557-.955-.594-.603.515-1.509.515-1.509s.573-.805 3.746-2.026c3.175-1.224 3.709-.813 3.872-.678.163.132.182.571.114.868-.067.296-.459 1.357-.67 1.913-.21.552-.295 1.308.564 1.49.86.181 2.063-.007 3.192-.414 2.694-.963 3.5-2.138 7.951-5.369l.029-.021z",
    style: {
      fill: "url(#aq)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.627 71.186c-.59 1.104-1.083 2.43-1.345 3.26-.042.198-.055.308-.055.308s-.111.609-.049.965c.026.149.064.26.099.349q.03.07.051.125a.4.4 0 0 1 .032.104c.005.076-.042.572-.251 1.146v.002c-.06.164-.133.335-.224.502q-.036.068-.071.129c-.425.759-1.021 1.357-1.493 1.428-.303.045-.453-.109-.518-.359.012.343.08.689.269.896.38.413 1.457-.739 1.457-.739s.641-.736.898-1.92c.38-1.747.172-2.094.172-2.094s-.229-.362-.086-.794c.144-.429 1.08-2.838 1.845-3.736l.467-.524.002-.027-.196-.486a4 4 0 0 0-.358.423 60 60 0 0 0-.646 1.042",
    style: {
      fill: "url(#ar)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.479 92.808a4 4 0 0 1-.437-.332 62 62 0 0 1-1.099-1.011 37 37 0 0 1-.549-.513c-.258-.242-.488-.459-.641-.601l.1.334.048.082c.171.271.796 1.178 2.006 2.124 1.443 1.128 1.452.677 1.452.677s.058-.372-.276-.782a4 4 0 0 1-.188-.251v.002s.943 1.381-.416.271",
    style: {
      fill: "url(#as)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.585 92.04",
    style: {
      fill: "url(#at)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.895 78.105s.209-.707.226-.993l-.005.019s-.478 1.346-.31 2.013c-.02-.521.089-1.039.089-1.039",
    style: {
      fill: "url(#au)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.606 30.962.677.067c1.328-.375 2.461-.72 2.461-.72s1.178-.381 1.771-.593c.592-.21 1.016-.292 1.543-.381a10 10 0 0 1 1.593-.122c.372.007.494.113.494.113s.155.122.228.251.69 1.762 2.77 1.868c2.079.105 2.105-1.021 1.924-1.364-.21-.398-.835-.804-.835-.804s-.838-.536-1.016-.789c-.179-.251.033-.333.098-.35.063-.016 2.266-.463 2.541-.567l.02-.019-.524-.16s-.11.125-.734.291c-.624.167-1.151.229-1.623.292-.471.062-.471.223-.471.223l-.079.127c-.025.07-.064.299.348.598.494.36 1.092.698 1.34.968.247.27.546.729.011 1.059a1.57 1.57 0 0 1-.726.246v.011c-.232.02-.427.028-.594.028l-.145.008-.015-.012c-.471-.022-.695-.132-.994-.281-.414-.208-.706-.68-.858-1.013s-.486-.616-.486-.616c-.548-.313-1.58-.32-2.62-.14s-2.475.659-2.724.756-1.506.513-2.15.68c-.646.166-1.138.333-1.532.438-.396.103-3.195.936-4.242 1.248-1.049.311-1.721.429-1.721.429-1.574.16-2.045-.125-2.045-.125-.276-.116-.243-.491-.243-.491l.008-1.068s-.027-.403-.334-.569c-.305-.167-.727-.235-1.483-.27-.755-.035-1.567.041-1.949.125-.38.084-1.108.292-1.643.887-.533.597-.449 1.061-.449 1.061l.01.188c.143.228.387.488.803.688.946.452-1.059 1.25-1.059 1.25a18 18 0 0 1-2.057.724c-2.059.603-3.432.721-3.432.721l.632.237s5.094-.946 6.659-2.437c0 0 .583-.273.019-.82-.565-.545-.837-.709-.837-.709s-.382-.208.019-.719c.399-.509.859-.74 1.259-.869.399-.126 1.634-.232 2.725-.087 0 0 .458.039.426.379s-.081.813-.073.958.024.48.373.787c.352.309 1.023.422 1.023.422s1.17.212 2.648-.203c1.479-.414 3.402-1.063 5.067-1.518z",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.965 38.95.253.453-.033.013c-1.038.48-3.725 1.23-3.976 1.303-.252.074-.155.218-.155.218.028.073.92 1.031.92 1.031 1.098 1.163.462 2.139.462 2.139s-.793 1.255-2.65 1.043a3.01 3.01 0 0 1-2.542-1.909c-.104-.263-.183-.715-.202-1.02-.022-.307-.255-.298-.255-.298-.997-.028-2.689 1.014-2.689 1.014-.768.438-1.566 1.069-3.243 1.824-.818.369-1.578.667-2.13.872l-.901-.162.085.45q-.058.019-.058.02s-2.111.765-4.22 1.446c-2.111.682-3.4.746-3.4.746s-1.245.111-2.111-.248c-.866-.36-.894-.876-.875-1.318s.451-1.308.58-1.824c.129-.517-.636-.6-.636-.6s-1.824-.22-3.4.276c-1.576.498-2.366 1.079-2.366 1.079-.849.477-.805.891-.805.891s-.011.435.513.809.999.471 1.618.61c.621.139.738.289.738.289 1.005.833.386 1.663.043 2.267-.589 1.037-3.423 1.54-3.423 1.54-3.052.706-4.769 1.006-7.291 1.353L62 52.828l-.257.573c-6.604.872-9.377 1.749-10.308 1.989s-1.175.73-1.276.842.074.159.074.159c.398.128.603.412.603.412s1.303 1.581-.012 2.895c-1.266 1.267-2.594 1.56-2.594 1.56s-2.028.687-3.798.317c-1.769-.372-2.272-1.759-2.25-2.23s.164-1.001.646-1.547c.482-.545.61-.621.61-.621s.333-.26.392-.387c.074-.16-.377-.217-.377-.217-.963-.121-3.256-.09-5.423.123a42 42 0 0 0-3.333.482l-.208-.448-.506.582-2.907.469c-1.41.207-2.399-.026-2.399-.026s-1.24-.37-1.378-1.166c-.138-.794.334-1.742.456-2.028.121-.286.466-.87.466-.87s.063-.121.063-.317-.217-.499-.217-.499-.191-.369-.826-.354-.806.122-1.065.339a.5.5 0 0 0-.101.118.6.6 0 0 1 .068-.147c.196-.288.606-.622 1.305-.652.697-.031.97.212.97.212.67.764.107 1.719-.327 2.571a2.6 2.6 0 0 0-.213.45q-.045.107-.081.211c-.334.987.272 1.458.622 1.547.35.091 1.063.531 3.977-.029 2.916-.562 3.342-.681 3.342-.681s5.724-1.013 8.347-.396l.022.004s1.208.342.308 1.243c-.9.9-1.611 1.506-1.402 2.215.208.71 1.181 1.773 3.397 1.493 0 0 .785-.105 1.03-.154 1.614-.313 2.7-1.181 2.7-1.181s.906-.672.729-1.519c-.174-.846-.947-1.108-.947-1.108s-.614-.395-.131-1.152c0 0 .131-.643 2.378-1.227 2.247-.583 6.347-1.414 9.833-1.853 3.251-.38 8.991-1.467 10.144-1.938 1.153-.473 1.395-1.304 1.418-1.591.023-.289.068-.773-1.061-1.016-1.13-.241-1.638-.61-1.798-.736-.161-.128-.508-.45-.508-1.188 0-.737 1.499-1.625 3.159-2.189s3.657-.317 3.657-.317c1.816.156.873 1.829.873 1.829-.072.3-.884 1.663.466 2.021 1.435.381 3.886-.323 4.83-.623.772-.243 2.923-1.001 4.368-1.509l.846-.297c1.543-.537 2.811-1.135 3.527-1.566.718-.43 1.996-1.208 1.996-1.208s1.257-.693 1.675-.753 1.507-.322 1.649.718c.145 1.039.587 1.769 1.305 2.116a3.13 3.13 0 0 0 3.024-.215c1.1-.718.335-1.771.335-1.771l-.055-.08a3.4 3.4 0 0 0-.455-.601 13 13 0 0 0-.686-.766c-.276-.406.048-.645.395-.777.347-.131 2.188-.706 2.188-.706 1.077-.357 1.483-.513 1.913-.92.415-.391-.177-1.249-.225-1.315l.004-.002.568.238q.189.252.373.51l-.005.005s.209.491.049.744c-.087.139-.318.273-.507.368z",
    style: {
      opacity: 0.3,
      fill: "url(#av)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.161 112.812c-.032-.038-.039-.031-.011-.059.019-.018.081-.076.109-.127 0 0-1.091-.058-1.994.072-.896.127-1.8.312-1.8.312l.28.136s.119-.048.976-.167 1.177-.119 1.177-.119.752-.058.903-.058.057.097.057.097-.075.125.34.115c0 0 .618-.027 1.224-.174 0 0-1.054.218-1.261-.028M70.378 113.195s.137.248-2.722.367c0 0 1.666.047 3.083-.185 1.032-.167-.361-.182-.361-.182M31.854 36.029s-.005.089.018.122c.022.032.1.105.1.105s.306-.466.181-.409c0 0-.111.174-.153.215 0 0-.027.037-.082.072s-.061.021-.064-.105M29.508 38.493s-.361.429 0 .484l.492-.491s.13-.218.13-.371c0 0-.476.231-.622.378",
    style: {
      opacity: 0.1,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.287 48.932c1.143.136 1.396-.123 1.423-.16a26 26 0 0 0 2.669-.193c1.569-.196 3.32-.83 3.32-.83s1.448-.529 1.953-1.099l.015-.002s-.646-.559-.985-1.045c0 0-.266-.519.025-.964.295-.446.779-.939 2.184-1.53 1.403-.593 2.195-.479 2.195-.479s.553-.006.938.419c.386.426.605.937.605.937s.027.354-.107.586l-.145.259s.046.015.352-.007c.306-.019 1.085-.132 2.488-.471 1.405-.338 3.174-.905 3.174-.905s4.565-1.47 5.037-1.597c.473-.126 1.265-.406 1.265-.406l.025.055s.377.617.365 1.182v-.053s-.02.28-.65.762c-.628.482-1.142.447-1.563.412s-.619-.066-.74-.042l-.671.037c-.733.103-1.14.379-1.14.379-1.681.992.681 8.651.681 8.651-3.486.438-7.586 1.27-9.833 1.853-2.247.584-2.378 1.227-2.378 1.227-.483.758.131 1.152.131 1.152s.772.263.947 1.109c.177.847-.729 1.518-.729 1.518s-1.08.904-2.7 1.181c-1.619.278-2.232.326-3.195-.438-.847-.671-.276-1.736.291-2.144.57-.408.847-.847.92-1.037s.03-.35.03-.35l-.54-.497c-1.868-1.239-9.208.059-9.208.059-.199-1.089-.337-1.091-.263-2.904.048-1.159.271-1.632.271-1.632l.054-.153s.417-1.344 1.063-2.273c0 0 .561-.16 1.271-.325a29 29 0 0 1 1.155-.242",
    style: {
      fill: "#393939"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.081 42.628s-3.805 1.235-3.625 1.168c0 0-.363.07-.638.15-.274.08-.502.23-.502.23s-3.063 1.138-5.997 1.721-2.773-.336-2.523-.773c.216-.381.772-1.036-.175-1.168-.949-.13-1.665.234-2.059.409-.393.176-2.946 1.269-1.166 2.1 0 0 1.326.598-.351 1.635 0 0-1.692 1.08-4.989 1.649 0 0-.526.059-1.752.103a15.3 15.3 0 0 0-3.837.613c-1.284.364-1.856.539-2.557.992l.181-.467.186-.43c.996-.497 3.464-1.2 5.326-1.284 1.86-.083 2.709-.149 4.398-.581 1.988-.509 2.517-.949 2.729-1.083.181-.115.718-.447.459-.59-.334-.185-.833-.679-.833-.679-.202-.239-.364-.348-.147-.975.332-.959 2.046-1.531 2.046-1.531s.958-.497 2.174-.479 1.199.701 1.199.701.057.317-.25.77c0 0-.469.539-.046.611.423.075 1.511.167 5.105-.958s7.532-2.432 7.532-2.432.112.317.112.578",
    style: {
      fill: "url(#aw)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.651 46.65c-.504.57-1.953 1.099-1.953 1.099s-1.751.634-3.32.83c-1.498.187-2.587.195-2.587.195l-.076-.002c-.163.134-.45.175-.678.196-.227.021-.751-.036-.751-.036s-2.008.402-2.424.574c0 0-.236.365-.309.502-.074.136-.278.553-.278.553.996-.497 3.464-1.2 5.326-1.284 1.86-.083 2.709-.148 4.398-.581 1.988-.509 2.517-.949 2.729-1.083.181-.115.718-.447.459-.59-.334-.185-.833-.679-.833-.679-.202-.239-.364-.348-.147-.975.332-.959 2.046-1.531 2.046-1.531s.958-.496 2.174-.479c1.216.019 1.199.701 1.199.701s.057.317-.25.77c0 0-.469.539-.046.612.424.074 1.511.166 5.105-.958 3.595-1.125 7.532-2.433 7.532-2.433-.091-.271-.276-.608-.276-.608s-.792.28-1.265.406c-.472.127-5.037 1.597-5.037 1.597s-1.77.566-3.174.905-2.182.452-2.488.473-.352.006-.352.006.012-.026.145-.26c.134-.231.107-.586.107-.586s-.219-.511-.605-.937-.938-.419-.938-.419-.791-.113-2.194.479c-1.405.592-1.89 1.084-2.185 1.53-.291.445-.025.964-.025.964.34.486.985 1.045.985 1.045",
    style: {
      fill: "url(#ax)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.765 55.951s-.06-.305.161-.875c.218-.569.846-.554 1.269-.468.423.088.788.278 1.371-.116.584-.394.438-1.475.043-2.656-.394-1.181-.306-1.983-.306-1.983l-.566-.605-.221.648c.044 1.226.612 3.005.772 3.502s.277.745-.685.481c-.963-.263-1.415.116-1.415.116-1.241.803-1.008 2.013-1.008 2.013z",
    style: {
      opacity: 0.2,
      fill: "url(#ay)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.254 60.974c-.246-1.642-.854-2.561-.854-2.561-.233.176-.478.646-.478.646s.167.194.439 1.461c0 0 .131.099.407.26.276.16.486.194.486.194M50.521 57.479s-.727.845-.352 2.176c0 0 .423-.353.545-.633 0 0-.135-.427.129-.948.002-.001-.119-.392-.322-.595",
    style: {
      opacity: 0.5,
      fill: "#141414"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.387 55.962c.016-1.21.439-1.39.843-1.694.406-.305 1.235-.023 1.235-.023s.631.203.975-.093-.016-1.367-.202-1.977c-.188-.609-.382-1.49-.415-2.107-.023-.456-.085-.659-.116-.735l-.191.563c.044 1.226.612 3.005.772 3.502s.277.745-.685.481c-.964-.263-1.415.116-1.415.116-1.241.803-1.008 2.014-1.008 2.014l.242-.025z",
    style: {
      opacity: 0.35,
      fill: "url(#az)"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.081 58.791c.042.056.392.556.686 1.969l.005.023c.274.159.483.191.483.191-.246-1.642-.854-2.561-.854-2.561-.114.086-.23.241-.32.378M50.521 57.479s-.727.845-.352 2.176c0 0 .116-.097.244-.23l.019-.048c-.283-.962.264-1.642.264-1.642l.003-.003a1 1 0 0 0-.178-.253",
    style: {
      opacity: 0.3,
      fill: "#505050"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.011 30.755h.147v.073c-.354.24-.627.69-.884 1.032-.229.305-.548.576-.774.884-.432.588-.83 1.167-1.253 1.77-.259.368-.983 1.181-1.068 1.622h.037c.175-.128.603-.184.81-.147l.037.183c-.261.381-.342.975-.699 1.254-.123.096-.408.127-.591.148v-.037c.106-.11.593-.968.554-1.033-.041-.026-.035-.022-.111-.036-.127.09-.803.268-.885.22-.04-.034-.002.003-.037-.037.207-.167.297-.469.442-.7.26-.412.846-1.026.995-1.475h-.109c-.147.11-1.128.421-1.364.442q-.018-.056-.038-.11c.195-.25.296-.554.479-.811.144-.203.345-.368.48-.59-.077-.043-.07-.026-.111-.111.247-.186.541-.388.921-.441v.037c-.223.214-1.016 1.202-1.068 1.511h.074c.254-.197.883-.175 1.104-.369.141-.123.218-.362.332-.515.339-.462.724-.898 1.069-1.364.218-.296.646-.563.775-.923-.093-.053-.08-.021-.11-.147.217-.127.673-.204.846-.33M68.793 35.473c.389-.012.957-.031 1.179.147.031.043.029.063.038.147-.176.206.027.715.295.737.287-.192.733-.152 1.068-.294.217-.092.438-.314.59-.479.283.002 1.222.341 1.291.517h.036c-.313.688.021 1.478-.185 2.284-.349 1.372-1.012 2.469-1.991 3.208-.242.183-.414.532-.773.589v-.036c.971-.927 1.435-2.138 1.806-3.687.096-.401-.014-1.756-.146-1.953-.056-.083-.124-.096-.258-.11-.23.149-.566.128-.849.22-.603.197-1.283.393-1.88.59-.246.082-.857.144-.921.369.169.14.225.422.331.627.212.403.544.644.553 1.253-.098.035-.255.039-.403.037l-.555-.184c-.353-.578-.529-1.249-.921-1.77-.112-.147-.416-.111-.516-.257.184-.109.461-.284.774-.258.13.011.343.118.515.075.226-.058 1.293-.365 1.438-.48.03-.037.013-.01.038-.074-.218-.246-.209-.73-.627-.774-.07-.044-.196-.022-.221-.037-.021-.026-.055-.002-.037-.073h.037c.06-.194.17-.217.294-.334M75.464 36.726c.44-.021.996.023 1.033.405-.25.163-.245.408-.369.7-.06.139-.193.272-.258.406-.029.058-.053.036 0 .073.078.069.101.034.147.148.057.1-.019.156 0 .258.027.168.145.414.222.589.246.56.673 1.142.736 1.844-.096.053-.148.09-.294.11-.186-.141-.469-.17-.554-.405v-.295c-.11-.38-.344-.798-.516-1.144-.087-.17-.088-.392-.259-.479-.248.379-1.316 1.394-1.806 1.474v-.036h.037c.182-.278.505-.442.699-.702.494-.656 1.251-1.647 1.144-2.728-.109-.031-.14-.05-.185-.146a.55.55 0 0 0 .223-.072M31.234 48.152c-.04-.034-.004.003-.038-.037-.075.016-.071.009-.109.037-.268.138-.721 1.328-1.254.996-.272.002-.297-.051-.443-.149.018-.35.614-.99.85-1.142.029-.563.174-1.166.11-1.695q-.056-.02-.11-.036c-.13-.043-.233.156-.333.257-.27.271-.604.556-.811.884-.314-.003-1.317-.012-1.511.111h-.111c.092-.239.802-1.021.59-1.364l-.037-.111c-.673.002-1.483 1.199-1.696 1.695-.107.248-.107.534-.257.737v.037l1.511-.185c.191-.041.453.048.59-.036h.516q.128-.166.258-.332c.308-.325.716-.654.958-1.031h.111v.514c-.282.254-.72.647-.848 1.032v.295c-.189.82.208 1.238.922 1.18.466-.434 1.233-.79 1.142-1.657m-4.312-.7h-.223c.102-.406.5-.871.996-.885v.184l-.516.664c-.106-.002-.2-.002-.257.037M106.315 47.636a11 11 0 0 0-.443-.996c-.278-.534-.571-1.317-1.363-1.327-.197.167-.404.3-.517.552-.725 1.642.765 3.491 1.438 4.388.238.316.518.663.884.846-.084 1.282-1.179 1.689-2.358 1.18-.838-.36-1.506-1.153-2.028-1.844-.177-.232-.45-.425-.626-.664-.164-.222-.282-.472-.479-.664v-.036h-.073c.102.397.329.759.479 1.106.622 1.433 1.414 2.435 2.617 3.28.567.399 1.51 1.029 2.322.442 1.421-1.022.729-4.833.147-6.263m-.11 1.77c-.096.093-.501-.39-.59-.479-.412-.413-1.238-1.138-.773-1.843h.184c.361.375.695.734.922 1.252.12.278.142.75.294.996-.023.064-.007.036-.037.074M82.837 51.433c.075.014.07.008.11.037.029.037.013.01.037.073.051.083.02.122 0 .221-1.015.248-.697 1.236-.923 2.249-.167.752-.128 1.65-.294 2.396v.368l-.479 3.76c-.09.048-.104.066-.259.073-.524-.811-1.337-1.446-1.916-2.211-.186-.245-.431-.702-.737-.811-.044.449-.183.924-.294 1.327-.245.879-.355 1.752-.555 2.617-.093.05-.129.07-.294.074-.277-.447-.688-.803-.994-1.215-.787-1.061-1.681-2.008-2.47-3.06-.188-.25-.477-.452-.664-.7-.426-.564-.957-1.398-1.695-1.623-.284-.086-.589-.005-.885 0-.055-.094-.089-.116-.11-.258l.11-.037c.279-.204.769-.153 1.143-.257.721-.202 1.389-.551 2.137-.665l.038.11c.068.096.05.11.036.222-.253.03-.52.229-.589.443-.066.083-.074.176-.074.332.885 1.119 1.836 2.143 2.69 3.28.445.591 1.124 1.101 1.474 1.769.029-.038.014-.01.038-.074.151-.236.104-.62.184-.921.156-.587.333-1.269.368-1.917-.259-.185-.472-.52-.663-.775-.361-.479-.928-.885-1.29-1.363-.239-.318-.596-.782-.994-.922-.248-.087-.563-.001-.774-.037v-.074c-.033-.047-.033-.09-.037-.183h.037v-.038c1.08-.057 1.914-.596 2.875-.737.061.104.096.125.11.295-.31.115-.64.219-.663.626.108.115.162.278.258.406l.405.368c.331.349.73.74.995 1.143h.037v-.073c.158-.236.107-.655.184-.958.249-.992.446-1.696-.848-1.623l-.037-.11c-.029-.043-.028-.062-.037-.147.332-.172.757-.143 1.18-.258.468-.125.896-.367 1.402-.442l.035.11c.033.048.034.092.037.185-.23.111-.562.24-.7.442-.242.355-.246.805-.368 1.291-.164.647-.371 1.391-.405 2.1.257.201.465.514.663.775.328.434.815.781 1.143 1.216.146.193.292.483.516.59v-.075c.169-.272.066-.993.147-1.363.236-1.07.136-2.308.37-3.391.068-.323.085-1.166-.037-1.401-.188-.361-.576-.195-.995-.332l-.037-.221.11-.037c.217-.138.521-.076.811-.147.385-.095 1.154-.235 1.437-.442M28.101 63.816c-.993-.052-1.828-.605-2.801-.7-.03.828-.204 1.638-.148 2.507.068.048.063.072.148.11.041.027.035.023.111.037.152-.248.604-.999.92-1.031.712.917.917 3.037.185 4.127-.203.301-.564.734-1.216.554-1.791-.5-1.671-4.042-1.659-6.34h.074v.036c.197.196.117.876.111 1.252.141.247.033.897.11 1.218.226.951.353 1.801.957 2.359.174.159.618.43.922.221.705-.186.944-1.521.625-2.285-.374.399-.526.982-1.253 1.032a.45.45 0 0 0-.184-.074c-.646-1.005-.133-2.566-.111-3.869l-1.548-.48.074-.7c.207.027.357.125.517.185.611.223 1.245.358 1.842.552.381.125.838.072.847-.405-.203-.201-.332-.441-.625-.554l-1.107-.184c-.559-.187-1.065-.964-.847-1.88.066-.279.17-.526.294-.738h.037v.037c.081.064.092.089.111.221-.272.208-.202.605-.148.959.161.12.265.29.479.368l1.254.222c.749.31 1.059 1.155.922 2.249h.037v.037c.221.009.97.187 1.105.294.03.044.028.063.037.149-.072.11-.073.342-.072.514M110.186 73.438c-.01-1.078-.035-2.342-.038-3.464h-.036c-.175.253-.515.382-.701.625-.079.107-.144.263-.257.332l-.221.039c-.296-.184-.717-.093-.738-.553.03-.038.013-.011.037-.074 1.24-.134 2.064-1.029 2.766-1.732.265-.268.682-.613.811-.995.076-.215-.015-.911-.075-1.18v-.442c-.117-.535-.098-1.211-.22-1.733l-.037-.479c-.117-.335-.55-.402-.627-.737-.017-.112.055-.162.148-.259.261-.004.442.031.625.075.31.676.154 1.649.333 2.47.091.416.056.978.146 1.4v.59c.124.576-.059 1.333.074 1.953.106.498.107 1.457 0 1.954v.627c-.097.446-.121 1.003-.222 1.399h-.073v-.221c-.094-.154 0-1.059 0-1.438 0-1.182-.029-2.372-.036-3.538h-.038v.074c-.496.438-.804 1.094-1.289 1.547.012 1.329.033 2.669-.222 3.76zM49.59 72.11c.496-.008 1.032-.148 1.473-.259.882-.217 1.676-.065 1.659-1.178l.258-.036v.073c.103.159.058.377.111.589.064.255.367 1.354.294 1.511-.31.209-.888.126-1.29.222-.548.131-1.146.149-1.732.295-.35.086-.729.173-1.143.185l-.221-2.138c1.167-.536 1.738-2.149 1.29-3.907-.345-1.361-.827-2.185-1.952-2.764-.395-.202-1.07-.411-1.697-.259-1.239.304-2.005 1.107-2.359 2.286-.435 1.455.217 3.386.811 4.201.198.27.598.566.921.7.19.08.522.061.626.221l.553 2.028q-1.935.33-3.87.664v-.037h-.038l-.405-2.139h.075c.048-.032.092-.032.184-.036.024.25.162.521.369.589.324.306 1.736-.037 2.174-.148.214-.053.437-.004.59-.109.029-.038.014-.01.037-.074-.054-.086-.052-.25-.11-.332v-.036c-1.813-.025-3.03-1.384-3.465-2.838-.189-.632-.257-1.571-.037-2.249.56-1.717 1.764-2.572 3.539-3.096.365-.107 1.269-.33 1.771-.222.566.124 1.106.131 1.584.332 1.054.446 1.887 1.254 2.285 2.359.102.286.073.533.147.848a3.46 3.46 0 0 1-.038 1.548c-.1.359-.253.766-.441 1.07a4.4 4.4 0 0 1-1.145 1.214c-.12.085-.767.366-.809.443z",
    style: {
      opacity: 0.72000002,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.886 65.107c-.085-.209-.479-.825-.848-.59h-.074c.024-.064.007-.035.037-.074-.001-.175-.021-.233-.073-.332l-.223-.036c-.036.029-.008.013-.072.036.025.223.104.23.11.479-.591.544-1.098 1.846-.663 2.95.08.203.237.54.404.663.081.059.123.037.186.111 1.219.105 1.715-1.996 1.216-3.207m-.552 2.434c-.074.079-.215.108-.296.183-.771-.058-.833-1.466-.554-2.137.082-.199.247-.326.369-.48.076-.014.071-.009.11-.037.279-.001.358.053.516.148.281.663.322 1.82-.145 2.323M83.315 83.941l-.036-.221c.392-.163 1.077-.328 1.216-.737.252-.31-.003-1.503-.11-1.88-.429-1.508-.657-3.137-1.105-4.608-.167-.545-.182-1.369-.7-1.547-.331-.255-1.14.173-1.29.073-.05-.062-.061-.117-.073-.221h.037v-.038c.328-.036.642-.201.92-.294.561-.188 1.068-.273 1.622-.48.586-.219 1.263-.566 1.917-.664l.036.258c-.412.154-1.132.376-1.179.885-.139.209.082 1.185.147 1.4.347 1.124.559 2.388.885 3.538.107.383.094 1.086.294 1.363v-.037c.306-.342.581-1.143.812-1.584a59 59 0 0 0 1.695-3.575c.222-.502.792-1.381.849-1.953-.189-.262-.147-.695-.479-.812-.29-.255-1.214.152-1.254.11l-.073-.037v-.222c.295-.031.541-.197.774-.295.75-.311 1.473-.496 2.212-.81.361-.154.751-.413 1.18-.48.021.103.063.174.036.222-.159.193-.492.261-.699.405-.153.107-.24.277-.369.405-.084.9.197 1.662.405 2.396.323 1.146.469 2.333.774 3.465.154.577.212 1.882.626 2.137.359.223.956-.117 1.217-.184q.017.129.037.258c-1.048.395-2.104.852-3.134 1.289-.147.063-.989.338-.994.332a.6.6 0 0 1-.074-.222c.397-.148 1.014-.396 1.18-.773.168-.388.023-1.005-.074-1.364-.264-.979-.365-1.981-.626-2.912-.137-.485-.207-.959-.332-1.4-.061-.218-.014-.522-.185-.626-.072.542-.563 1.249-.774 1.731-.556 1.264-1.105 2.48-1.731 3.685-.214.41-.808 1.269-.848 1.734l.185.588.221.186c.568.011.884-.112 1.29-.221q.017.128.038.257c-.951.353-1.887.629-2.877.959-.508.174-1.022.437-1.589.521M110.223 83.242a2 2 0 0 0-.407-.037c-.132.121-.331.152-.478.259-.467.335-.955.896-1.29 1.362-.269.375-.498.785-.738 1.181-.104.172-.126.375-.257.515v.074c.321-.054.509-.263.737-.404a28 28 0 0 0 1.732-1.142c.274-.201.479-.512.773-.702.027-.439.116-.786-.072-1.106m-.848 1.289c-.223.165-.437.395-.663.555-.194.134-.427.206-.59.367h-.037c.121-.38.763-1.032 1.068-1.252.157-.115.356-.146.517-.26h.146c.033.044.031.042.074.074-.035.279-.333.38-.515.516M31.013 89.545c-.062-.416-.296-.79-.442-1.144-.326-.793-.581-1.631-.849-2.432-.154-.467-.259-.922-.405-1.364-.074-.229-.058-.49-.185-.664v-.11c.25.09.632.081.848.222h.187c-.042-.192-.08-.513-.187-.664-.112-.182-.825-.184-1.031-.33-.29-.229-.565-.883-.774-1.217-.522-.827-1.213-1.707-1.991-2.285-.413-.307-.699-.625-1.438-.628l-.257.185c-.166.736.129 2.094.551 2.434v.073a1.1 1.1 0 0 1-.479-.258h-.037c.007.211.048.488.147.626.043.182.337.329.516.368.231.966.552 1.958.885 2.84.269.708.406 1.381.699 2.063.144.332.487.574.591.922h.109c-.083-.312-.252-.604-.367-.885-.339-.815-.609-1.679-.887-2.505-.181-.542-.306-1.068-.479-1.586-.064-.195-.046-.398-.147-.553v-.037c.25.045.4.176.59.259.43.188.841.259 1.29.442.329.134.742.322 1.144.367.045.336.236 1.21.405 1.438v.111c-.561-.386-.549-.932-1.549-.848a.8.8 0 0 1-.184.146 1.3 1.3 0 0 0 0 .849c.24.602.999 1.855 1.622 2.027.24.171.591-.04.699-.223.225.119.273.634.368.886.198.519.487 1.202.96 1.438v.037zm-2.359-6.561c-.39-.027-.721-.181-1.033-.295-.833-.309-1.586-.573-2.321-.923-.088-.334-.708-1.529-.369-1.952l.074-.111c.075-.015.071-.009.11-.037 1.136.137 2.275 1.517 2.838 2.285.22.299.401.745.701.959zm.589 3.205-.332.406c-.098.072-.208.102-.295.184-.633-.019-.655-.639-.921-1.032.004-.362.142-.363.294-.553.085-.007.104-.007.147-.036.572.004.702.261 1.033.479.054.221.089.314.074.552M49.184 85.158c.531-.008 1.322.503 1.327.995-.64.416-.978 1.023-1.4 1.659-.167.25-.452.509-.516.848.363.177.652.535 1.032.664v-.038c.184-.149.887-1.486.958-1.77.054-.216-.128-.382-.074-.516.047-.092-.016-.026.074-.073.362-.231 1.342.472 1.364.811-.845.418-1.271 1.303-1.807 2.027-.271.369-.798.733-.958 1.18h.109c.218-.146.544-.135.813-.221.393-.13.78-.341 1.217-.406v-.11c-.221-.128-.505-.371-.592-.626h.038v-.037c.768.147 1.453.53 1.918.995l.037.626a1 1 0 0 1-.11.036c-.213.113-.827-.478-.959-.625-.494.22-.999.492-1.475.736.037.03.01.014.074.037.208.197.51.263.664.515l.185.886c.206.688.604 1.529.442 2.396h-.258c-.229-.337-.484-.479-.626-.958-.081-.271.033-.611-.037-.921-.162-.709-.282-1.332-.7-1.769-.457.194-.84.358-1.144.7-.454-.102-.905-.562-.92-1.105.056-.021.062-.024.147-.037.088.064.213.074.368.074.3-.458.914-.866 1.032-1.476-.846-.374-1.518-.58-2.138-1.181v-.073c.09-.031.228-.038.367-.036.096.066.503.101.554.073.233-.251.298-.654.443-.995.221-.526.496-1.133.626-1.732.042-.199-.073-.326-.075-.553M109.484 85.784a.7.7 0 0 1-.109-.147h-.222c-.223.189-.532.276-.774.442-.374.263-.706.615-1.069.885-.163.125-.403.236-.516.405-.187.279-.149.75-.368.995v.147c.294-.107.431-.451.664-.625.284-.216.525-.5.811-.702.179-.125.382-.194.552-.332.118.021.107.034.186.075-.017.936-.511 1.597-.812 2.286-.086.2-.112.514-.258.662-.069.071-.213.087-.294.147q-.368.405-.739.812c-.233.32-.341.748-.588 1.069-.002.106-.002.2.035.257.037.029.103.055.148.075.474-.451.935-.826 1.327-1.365.612-.842.919-1.907 1.364-2.911.28-.635.684-1.26.662-2.175m-2.912 5.678v.036h-.037c.064-.441.401-.564.555-.886h.073c-.047.367-.325.694-.591.85",
    style: {
      opacity: 0.72000002,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.47 92.051c.437.088 1.639.606 1.658 1.069.071.106.007.232-.036.331a.6.6 0 0 1-.186.037c-.188.086-.355-.129-.479-.221-.249-.185-1.031-.898-.957-1.216M58.694 93.23c-.221.063-.478.199-.7.258q-.258.019-.517.036c-.058-.599-.354-1.066-.368-1.694.554-.012 1.249-.084 1.62-.294-.008-.188-.042-.188-.11-.295-.422-.102-1.146-.117-1.475.108-.093-.004-.137-.004-.184-.036-.206-.261-.108-.791-.294-1.068v-.148c.397-.085 1.045-.155 1.253-.442.029-.038.013-.009.036-.072-.033-.034-.048-.065-.073-.112-.577-.146-.827-.046-1.326.148-.155-.5.032-.895-.479-1.033.109-.189.472-.182.7-.258a7 7 0 0 0 1.069-.441c.024-.064.007-.037.037-.074-.02-.187-.073-.181-.148-.295-.532-.041-.957.01-1.254.295h-.071c.044-.276.216-.668.367-.885.104-.151.296-.13.368-.332h.037v-.037l-.222-.294c-.173-.121-.423-.132-.589-.259-.245-.004-.48-.003-.626.073.019.142.083.231.111.332.102.381-.264 1.555-.406 1.733-.114.145-1.444.626-1.806.516a1.6 1.6 0 0 1-.405-.222c-.03-.038-.014-.009-.037-.073.522-.492.899-1.586 1.622-1.807l.038-.184c-.181-.186-1.058-1.107-1.511-.812q-.055.018-.109.036c0 .315.157.552.073.886-.17.663-.547 1.448-.885 1.99-.203.325-.646.681-.663 1.144.602-.061.747-.682 1.215-.85l.406.37c.193.289.157.725.257 1.104l.516 2.396q.036.59.075 1.18c.099.364.392.983.774 1.069.062.031.113.018.184-.038.129-.106.059-.291.148-.441.207-.148.573-.11.848-.185.754-.2 1.633-.186 2.469-.369.396-.086 1.051.149 1.364-.036q.056-.019.11-.039c-.018-.481-.94-.688-1.439-.549m-4.645-4.201c.059-.099 1.037-.256 1.144-.185.391.182.251.756.479 1.105-.077.182-.975.456-1.253.479-.05-.389-.115-1.188-.37-1.399m.48 1.806c.282-.025 1.012-.266 1.216-.406h.037c.071.337.111.911.295 1.18-.132.323-.946.296-1.254.479-.128-.077-.298-1.003-.294-1.253m2.064 2.875c-.445.095-.907.224-1.402.222-.076-.527-.327-.987-.331-1.548.567-.012.858-.239 1.326-.297.029.342.241 1.312.406 1.549zM49.368 92.529c.503.287.479 1.452.333 2.064-.119.076-.148.11-.369.11-.496-.752-.392-.915-.073-1.695.06-.151.053-.354.109-.479M89.729 100.897l.332-1.658.368-2.728c.109-.485.164-1.357-.146-1.586-.229-.165-.673-.104-.958-.036-.513.12-1.715.286-2.138 0-.788-.53.071-2.262.848-2.286.071.156.151.22.257.332 1.118.081 2.023-.45 3.098-.185.097.146.241.294.295.48.095.336.042 1.552-.038 1.916-.108.488-.028.986-.146 1.511-.184.811-.211 1.734-.406 2.507-.067.27-.019.496-.111.737-.159.416-.69.993-1.255.996M41.112 104.768c-.067-.379-.493-.594-.737-.813-.717-.637-1.383-1.44-2.21-1.951-.412-.256-1.005-.214-1.18-.701h.111c.056.038.149.037.257.037-.021-.457-.348-.615-.553-.886-.458-.606-1.119-1.54-2.137-1.548-.042.078-.054.068-.074.185.245.26.374.633.663.848.317.236.741.452.884.848h-.11c-.223-.227-.516-.396-.773-.591-.344-.258-.632-.675-.885-1.03-.099-.142-.384-.425-.294-.627.057-.17.176-.16.405-.147.31.212.877.308 1.216.518.731.447 1.899 1.414 2.211 2.247.076.204-.047.4-.038.48.353.329.895.495 1.292.772.479.338.997.716 1.438 1.107.119.104.206.273.332.368.345.261.948.688.996 1.215-.384.229-1.018-.077-1.365-.257-.963-.5-1.78-1.145-2.543-1.844-.246-.226-.661-.501-.625-.884h.147c.088.124.229.153.331.258.086.088.111.233.185.331.393.526 1.309 1.175 1.881 1.548.32.212.675.49 1.175.517M64.997 107.716c-.344-.612-.797-1.013-1.365-1.4-1.876-1.284-4.644-2.586-7.851-2.506-.155.097-.469.021-.663.074-.268.07-.432.207-.626.331-.007.905 1.347 1.394 2.101 1.584.45.114.846-.096 1.106-.186.201-.765-.723-.877-1.143-1.253h-.075v-.036c2.828-.112 4.945.678 6.561 1.88.404.301.866.729 1.07 1.216.075.182.108.478 0 .628-.148.41-.638.373-1.106.479-1.082.246-2.567-.364-3.06-.849-.101.177.045.449-.11.626-.164.446-.734.331-1.254.442-.854.186-2.192-.252-2.69-.589-.139-.094-.239-.266-.369-.369a.6.6 0 0 0-.038-.185c.075-.07.165-.174.221-.258 1.061-.08 1.6-.026 2.214.553-.016.075-.01.071-.038.109-.069.141-.228.158-.442.149v.072c.388.004.552-.054.773-.183l.037-.222c-.127-.129-.215-.305-.368-.406-.606-.396-1.855-.597-2.543-.146-.108.522.216.805.516 1.031.601.455 1.11.72 1.954.959.271.076.513.006.811.072.261.06.712.073.995 0 .47-.119 1.123-.615.589-1.18v-.036c.279.104.507.376.774.518.709.371 1.883.676 2.95.441.523-.115 1.065-.115 1.214-.589.167-.261-.063-.624-.145-.771m-8.184-3.097c.131.088.205.271.332.369-.003.093-.004.138-.037.186-.24.649-1.589.168-1.917-.076-.102-.075-.142-.231-.22-.33.014-.076.009-.072.038-.11.101-.283.388-.189.625-.332.467.003.89.097 1.179.293M90.65 104.988h.369v.074c.029.042.027.063.037.147-.455.495-.908 1.851-1.586 2.026v-.11c.252-.178 1.081-1.296 1.106-1.658h-.074c-.173-.108-.457.057-.59.109a3.14 3.14 0 0 0-1.143.775c.011.121.069.196.037.22-.037.051-.071.067-.11.11-.064-.022-.036-.007-.073-.036-.141-.047-.145-.074-.148-.259.175-.161.287-.411.479-.551a7 7 0 0 1 .773-.479c.278-.147.679-.173.923-.368",
    style: {
      opacity: 0.72000002,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.07 107.716c-.218.195-.752.213-.995.404h-.037c.096-.139.271-.198.369-.331.072-.098.102-.209.185-.295-.016-.075-.01-.07-.038-.109v-.074c-1.075-.198-2.873.73-3.427 1.217-.144.124-.23.313-.368.442a.7.7 0 0 0 .036.221c.653.044 1.877-.357 2.026-.885.029-.023.009-.001 0-.037v-.074c-.448-.026-1.048.071-1.326.333h-.036c.242-.371 1.138-.696 1.62-.848.16-.05.513-.14.665-.037l.11.037c-.086.368-.613.78-.96.885v.073c.568-.129 1.085-.387 1.585-.589.343-.141.732-.174 1.033-.369.213-.14.939-1.126.996-1.401-.853.133-.923.975-1.438 1.437m-2.912.737v.111c-.07.046-.12.147-.185.184-.192.112-.446.099-.627.222-.085-.009-.104-.007-.146-.038h-.037c.101-.316.708-.46.995-.479M67.098 111.696l2.727.111q-.017.055-.036.109c.279.026.206.159.369.26.278.169.769.322 1.105.403v.075h-.259c-.053.034-.121.034-.221.035.001-.117.063-.048-.036-.11-.35-.264-1.028-.098-1.438 0-.261.063-.554-.021-.699.147-.04.034-.004-.002-.036.037h.109c.308-.196 1.561-.149 2.064-.148v.074h-.296c-.193.121-.513.018-.774.074a6.5 6.5 0 0 1-1.399.147l-.038-.074c.062-.045.074-.077.112-.147-.116.004-.235.005-.296-.036-.029-.038-.013-.011-.037-.074q.296-.054.59-.109c-.037-.03-.01-.014-.073-.037-.222-.148-1.426.014-1.549.111h.073c.143.084.526.055.664.109v.036h-.037v.037c-.272-.086-.682-.091-.92-.147-.042-.077-.053-.066-.074-.185.089-.047.104-.065.257-.073.082-.05.209-.008.333-.037.147-.032.905-.187 1.07-.11v.074c.305.163 1.147.254 1.473.036-.04-.032-.002.003-.036-.036l-.663-.11v-.074q.055-.017.11-.037c.1-.063.305-.043.405-.11-1.02-.003-2.117-.031-3.097.037v.038h.038c.298.187 1.01-.124 1.4 0v.072h-.073c-.257.186-1.548.176-1.77 0-.029-.037-.013-.01-.037-.072.156-.082.365-.169.553-.222.151-.041.328.001.442-.074M33.188 44.024a3.6 3.6 0 0 0-.848-.074c-.082.298-.255.553-.368.811-.25.571-.472 1.141-.7 1.697-.193.462-.312 1.206-.59 1.583v.073c.387-.069.65-.459.884-.7.574-.591 1.789-2.068 1.77-3.169a1 1 0 0 1-.148-.221m-.7 1.475c-.169.278-.262.552-.443.811-.166.238-.429.421-.59.664h-.038c.048-.281.199-.508.297-.738.219-.522.369-1.041.625-1.51.142.003.25.014.332.073.089.048.026-.017.073.074.076.185-.167.477-.256.626M97.911 34.183c-.385-.387-.679-.874-1.069-1.254v-.036c-.192.068-.839.641-.958.811-.234-.088-.365-.34-.554-.479-.629-.473-1.222-1.087-2.32-1.069-.14.107-.342.11-.517.184-.495.214-1.008.64-1.216 1.143-.231.56.004 1.389.184 1.806.364.842.961 1.553 1.475 2.249.425.573.905 1.166 1.695 1.364.891.222 1.324-.824 1.659-1.218.345-.405 1.101-.502 1.364-1.031.096-.193.032-.573-.037-.737-.167-.397-.994-1.511-1.327-1.732.024-.222.126-.23.221-.369.23.113.315.439.479.627.21.24.508.369.737.589.352.003.564-.087.736-.258h.038c-.09-.246-.414-.417-.59-.59m-2.1 3.981c-.652.154-.974-.273-1.327-.627-.87-.871-1.462-1.95-2.138-3.022-.232-.368-.825-1.056-.516-1.585h.146c.187.279.503.473.702.738.55.73 1.225 1.368 1.769 2.101.336.452.707.876 1.031 1.326.166.232.296.527.518.7-.041.167-.112.245-.185.369m.552-2.616c.298.409.703.641.699 1.363-.113.108-.146.209-.331.257-.038.03-.01.014-.074.038-.52-.868-1.273-1.594-1.878-2.397-.197-.262-.504-.476-.7-.737-.338-.447-.739-.805-1.106-1.215-.107-.122-.156-.24-.294-.333.032-.08.031-.053.073-.11.624.006.926.426 1.289.701.903.675 1.658 1.515 2.322 2.433",
    style: {
      opacity: 0.72000002,
      fill: "#232323"
    },
    transform: "matrix(.35158 0 0 .35158 36.115 -4.734)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.453 40.205c.74.02 1.12.042 1.58.042s.961-.02 1.461-.042c.12.127.12.577 0 .705-1.04.17-1.475.984-1.967 1.986l-1.463 2.972 2.56 5.66h.091l3.801-8.781c.474-1.156.44-1.731-.86-1.837-.12-.128-.12-.577 0-.705.94.02 1.52.042 1.98.042.461 0 .961-.02 1.762-.042.12.127.12.577 0 .705-1.321.17-1.55.987-1.967 1.986l-4.737 10.896c-.14.32-.26.492-.48.492-.2 0-.354-.174-.46-.492l-2.692-6.202-2.951 6.202c-.12.32-.26.492-.48.492-.2 0-.34-.171-.46-.492l-4.353-10.938c-.61-1.517-.651-1.836-1.791-1.943-.12-.129-.14-.577-.02-.706.94.021 1.28.043 2.08.043.78 0 1.281-.021 2.222-.043.12.128.12.577 0 .706-1.26.148-1.315.486-.812 1.708l3.664 8.909h.091l2.236-4.854-1.687-3.82c-.67-1.517-.83-1.815-1.691-1.943-.12-.129-.14-.577-.02-.706.64.021.98.043 1.78.043.781 0 1.102-.021 1.822-.043.12.128.12.577 0 .706-.84.128-.76.49-.212 1.708l.984 2.159.088.095 1.06-2.125c.619-1.239.701-1.71-.16-1.837-.12-.13-.12-.579 0-.706M35.014 51.42c0 1.773.22 1.86 1.44 1.944.12.128.12.577 0 .705-.86-.02-1.36-.042-2.22-.042-.881 0-1.401.02-2.242.042-.12-.128-.12-.577 0-.705 1.22-.107 1.442-.17 1.442-1.944v-4.615c0-1.772-.22-1.858-1.442-1.943-.12-.129-.12-.577 0-.706.86.022 1.36.043 2.222.043.88 0 1.4-.02 2.241-.043.12.129.12.577 0 .706-1.22.106-1.44.17-1.44 1.943zM38.355 44.862c-.12-.129-.12-.577 0-.706.84.022 1.36.043 2.241.043.741 0 1.06-.02 1.921-.043.12.129.12.577 0 .706-.96.106-1.14.17-1.14 1.943v1.901c.66 0 1.246-.337 2.1-1.367 1.542-1.859 1.742-2.414.742-2.478-.12-.128-.12-.577 0-.705.86.021 1.62.042 2.2.042.52 0 .861-.02 1.402-.042.119.128.119.577 0 .705-.8.043-1.535.15-2.142.897l-1.72 2.115c-.341.385-.461.62-.461.79 0 .129.08.236.18.364l2.962 3.717c.262.325.74.555 1.28.62.12.128.12.555 0 .683 0 0-.98-.021-1.54-.021-.521 0-1.022.021-1.242.042v-.299c0-.277-.02-.512-.3-.854l-2.22-2.949c-.3-.427-.801-.534-1.241-.534v1.987c0 1.773.18 1.837 1.14 1.944.12.129.12.577 0 .705-.86-.02-1.18-.042-1.92-.042-.882 0-1.402.021-2.242.042-.12-.128-.12-.576 0-.705 1.22-.107 1.44-.17 1.44-1.944v-4.614c0-1.773-.22-1.837-1.44-1.943M52.46 51.42c0 1.773.22 1.86 1.44 1.944.12.128.12.577 0 .705-.86-.02-1.36-.042-2.22-.042-.881 0-1.401.02-2.242.042-.12-.128-.12-.577 0-.705 1.22-.107 1.44-.17 1.44-1.944v-4.615c0-1.772-.22-1.858-1.44-1.943-.12-.129-.12-.577 0-.706.86.022 1.36.043 2.222.043.88 0 1.4-.02 2.241-.043.12.129.12.577 0 .706-1.22.106-1.44.17-1.44 1.943zM60.323 53.364c.12.128.12.577 0 .705-.861-.02-1.361-.042-2.222-.042-.88 0-1.4.02-2.24.042-.121-.128-.121-.577 0-.705 1.22-.107 1.44-.17 1.44-1.944v-4.615c0-1.772-.22-1.858-1.44-1.943-.121-.129-.121-.577 0-.706.86.022 1.36.043 2.22.043.54 0 1.38-.043 2.12-.043 2.842 0 3.444 1.496 3.444 2.607 0 1.282-.821 3.332-3.503 3.332-.5 0-.9-.084-1.26-.256v1.581c0 1.773.22 1.859 1.441 1.944m-1.441-4.209c.4.171.9.235 1.3.235 1.202 0 1.722-.83 1.722-2.371 0-1.498-.642-2.158-1.822-2.158-.96 0-1.2.278-1.2.961zM68.184 49.22v3.204c0 .406.28.94.64.94h1.663c1.26 0 1.84-1.068 2.16-2.328.22-.064.38-.02.56.085-.14.898-.36 2.072-.6 2.948 0 0-1.32-.042-2.121-.042h-3.083s-1.4.02-2.241.042c-.12-.128-.12-.577 0-.705 1.221-.107 1.44-.17 1.44-1.944v-4.615c0-1.772-.219-1.858-1.44-1.943-.12-.129-.12-.577 0-.706.861.022 2.222.043 2.222.043h4.142c.4 0 .54-.043.82-.085q.06 0 .06.065c.04.148.28 1.815.36 2.542a.93.93 0 0 1-.54.107c-.36-1.218-.62-1.924-1.862-1.924h-1.54c-.38 0-.641.235-.641.599v3.033h1.14c1.401-.02 1.34-.235 1.38-1.196.101-.107.461-.107.561 0-.02.534-.04.918-.04 1.517s.02.94.04 1.56c-.1.107-.46.107-.56 0-.04-.79.04-1.197-1.38-1.197zM79.829 44.156c3.341 0 4.982 2.223 4.982 5.063 0 3.74-2.481 4.85-4.702 4.85-1.6 0-2.322-.043-2.921-.043-.88 0-1.4.021-2.241.042-.12-.128-.12-.576 0-.705 1.22-.107 1.44-.17 1.44-1.944v-4.614c0-1.773-.22-1.859-1.44-1.944-.12-.128-.12-.577 0-.705.86.021 1.36.042 2.221.042.38.001 2.14-.042 2.661-.042m-.201 9.208c2.201 0 3.443-.79 3.443-3.78 0-2.223-.46-4.722-3.823-4.722-.78 0-1.28.128-1.28.662v6.878c0 .599.14.962 1.66.962M89.432 51.42c0 1.773.219 1.86 1.44 1.944.12.128.12.577 0 .705-.861-.02-1.361-.042-2.222-.042-.88 0-1.4.02-2.24.042-.12-.128-.12-.577 0-.705 1.22-.107 1.44-.17 1.44-1.944v-4.615c0-1.772-.22-1.858-1.44-1.943-.12-.129-.12-.577 0-.706.86.022 1.36.043 2.22.043.88 0 1.402-.02 2.242-.043.12.129.12.577 0 .706-1.221.106-1.44.17-1.44 1.943zM96.553 53.364c.12.128.12.577 0 .705-.74-.02-1.74-.042-2.561-.042-.78 0-1.04.02-1.78.042-.12-.128-.12-.577 0-.705.87-.064 1.472-.196 2-1.516l4.449-11.116c.228-.573.379-.763.675-.763.28 0 .394.229.54.642l4.102 11.579c.37 1.1 1.025 1.1 1.801 1.174.12.128.12.577 0 .705-.74-.02-1.461-.042-2.282-.042-.78 0-1.88.02-2.621.042-.12-.128-.12-.577 0-.705.953-.073 1.778.005 1.48-.875l-1.22-3.61h-4.163c-.48 0-.6.084-.7.362l-1.101 3.097c-.311.878.63.97 1.381 1.026m4.263-5.383-1.94-5.704h-.041l-2.005 5.42c-.084.23.06.284.504.284z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWikipedia);
export default __webpack_public_path__ + "static/media/logo-wikipedia.ad16cf6e0b87b7113a006606517feb50.svg";
export { ForwardRef as ReactComponent };